/*jshint ignore: start*/

!(function (t, n) {
  "object" == typeof exports && "object" == typeof module
    ? (module.exports = n())
    : "function" == typeof define && define.amd
    ? define([], n)
    : "object" == typeof exports
    ? (exports.Scrollbar = n())
    : (t.Scrollbar = n());
})(window, function () {
  return (function (t) {
    var n = {};
    function e(r) {
      if (n[r]) return n[r].exports;
      var o = (n[r] = { i: r, l: !1, exports: {} });
      return t[r].call(o.exports, o, o.exports, e), (o.l = !0), o.exports;
    }
    return (
      (e.m = t),
      (e.c = n),
      (e.d = function (t, n, r) {
        e.o(t, n) || Object.defineProperty(t, n, { enumerable: !0, get: r });
      }),
      (e.r = function (t) {
        "undefined" != typeof Symbol &&
          Symbol.toStringTag &&
          Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }),
          Object.defineProperty(t, "__esModule", { value: !0 });
      }),
      (e.t = function (t, n) {
        if ((1 & n && (t = e(t)), 8 & n)) return t;
        if (4 & n && "object" == typeof t && t && t.__esModule) return t;
        var r = Object.create(null);
        if (
          (e.r(r),
          Object.defineProperty(r, "default", { enumerable: !0, value: t }),
          2 & n && "string" != typeof t)
        )
          for (var o in t)
            e.d(
              r,
              o,
              function (n) {
                return t[n];
              }.bind(null, o)
            );
        return r;
      }),
      (e.n = function (t) {
        var n =
          t && t.__esModule
            ? function () {
                return t.default;
              }
            : function () {
                return t;
              };
        return e.d(n, "a", n), n;
      }),
      (e.o = function (t, n) {
        return Object.prototype.hasOwnProperty.call(t, n);
      }),
      (e.p = ""),
      e((e.s = 58))
    );
  })([
    function (t, n, e) {
      var r = e(25)("wks"),
        o = e(16),
        i = e(2).Symbol,
        u = "function" == typeof i;
      (t.exports = function (t) {
        return r[t] || (r[t] = (u && i[t]) || (u ? i : o)("Symbol." + t));
      }).store = r;
    },
    function (t, n) {
      t.exports = function (t) {
        return "object" == typeof t ? null !== t : "function" == typeof t;
      };
    },
    function (t, n) {
      var e = (t.exports =
        "undefined" != typeof window && window.Math == Math
          ? window
          : "undefined" != typeof self && self.Math == Math
          ? self
          : Function("return this")());
      "number" == typeof __g && (__g = e);
    },
    function (t, n) {
      var e = (t.exports = { version: "2.6.9" });
      "number" == typeof __e && (__e = e);
    },
    function (t, n, e) {
      t.exports = !e(13)(function () {
        return (
          7 !=
          Object.defineProperty({}, "a", {
            get: function () {
              return 7;
            },
          }).a
        );
      });
    },
    function (t, n, e) {
      var r = e(2),
        o = e(3),
        i = e(11),
        u = e(6),
        c = e(10),
        s = function (t, n, e) {
          var a,
            f,
            l,
            p,
            h = t & s.F,
            d = t & s.G,
            v = t & s.S,
            y = t & s.P,
            m = t & s.B,
            g = d ? r : v ? r[n] || (r[n] = {}) : (r[n] || {}).prototype,
            b = d ? o : o[n] || (o[n] = {}),
            x = b.prototype || (b.prototype = {});
          for (a in (d && (e = n), e))
            (l = ((f = !h && g && void 0 !== g[a]) ? g : e)[a]),
              (p =
                m && f
                  ? c(l, r)
                  : y && "function" == typeof l
                  ? c(Function.call, l)
                  : l),
              g && u(g, a, l, t & s.U),
              b[a] != l && i(b, a, p),
              y && x[a] != l && (x[a] = l);
        };
      (r.core = o),
        (s.F = 1),
        (s.G = 2),
        (s.S = 4),
        (s.P = 8),
        (s.B = 16),
        (s.W = 32),
        (s.U = 64),
        (s.R = 128),
        (t.exports = s);
    },
    function (t, n, e) {
      var r = e(2),
        o = e(11),
        i = e(9),
        u = e(16)("src"),
        c = e(60),
        s = ("" + c).split("toString");
      (e(3).inspectSource = function (t) {
        return c.call(t);
      }),
        (t.exports = function (t, n, e, c) {
          var a = "function" == typeof e;
          a && (i(e, "name") || o(e, "name", n)),
            t[n] !== e &&
              (a && (i(e, u) || o(e, u, t[n] ? "" + t[n] : s.join(String(n)))),
              t === r
                ? (t[n] = e)
                : c
                ? t[n]
                  ? (t[n] = e)
                  : o(t, n, e)
                : (delete t[n], o(t, n, e)));
        })(Function.prototype, "toString", function () {
          return ("function" == typeof this && this[u]) || c.call(this);
        });
    },
    function (t, n, e) {
      var r = e(8),
        o = e(41),
        i = e(43),
        u = Object.defineProperty;
      n.f = e(4)
        ? Object.defineProperty
        : function (t, n, e) {
            if ((r(t), (n = i(n, !0)), r(e), o))
              try {
                return u(t, n, e);
              } catch (t) {}
            if ("get" in e || "set" in e)
              throw TypeError("Accessors not supported!");
            return "value" in e && (t[n] = e.value), t;
          };
    },
    function (t, n, e) {
      var r = e(1);
      t.exports = function (t) {
        if (!r(t)) throw TypeError(t + " is not an object!");
        return t;
      };
    },
    function (t, n) {
      var e = {}.hasOwnProperty;
      t.exports = function (t, n) {
        return e.call(t, n);
      };
    },
    function (t, n, e) {
      var r = e(44);
      t.exports = function (t, n, e) {
        if ((r(t), void 0 === n)) return t;
        switch (e) {
          case 1:
            return function (e) {
              return t.call(n, e);
            };
          case 2:
            return function (e, r) {
              return t.call(n, e, r);
            };
          case 3:
            return function (e, r, o) {
              return t.call(n, e, r, o);
            };
        }
        return function () {
          return t.apply(n, arguments);
        };
      };
    },
    function (t, n, e) {
      var r = e(7),
        o = e(17);
      t.exports = e(4)
        ? function (t, n, e) {
            return r.f(t, n, o(1, e));
          }
        : function (t, n, e) {
            return (t[n] = e), t;
          };
    },
    function (t, n, e) {
      var r = e(1);
      t.exports = function (t, n) {
        if (!r(t) || t._t !== n)
          throw TypeError("Incompatible receiver, " + n + " required!");
        return t;
      };
    },
    function (t, n) {
      t.exports = function (t) {
        try {
          return !!t();
        } catch (t) {
          return !0;
        }
      };
    },
    function (t, n) {
      t.exports = {};
    },
    function (t, n, e) {
      var r = e(10),
        o = e(49),
        i = e(50),
        u = e(8),
        c = e(19),
        s = e(51),
        a = {},
        f = {};
      ((n = t.exports =
        function (t, n, e, l, p) {
          var h,
            d,
            v,
            y,
            m = p
              ? function () {
                  return t;
                }
              : s(t),
            g = r(e, l, n ? 2 : 1),
            b = 0;
          if ("function" != typeof m) throw TypeError(t + " is not iterable!");
          if (i(m)) {
            for (h = c(t.length); h > b; b++)
              if (
                (y = n ? g(u((d = t[b]))[0], d[1]) : g(t[b])) === a ||
                y === f
              )
                return y;
          } else
            for (v = m.call(t); !(d = v.next()).done; )
              if ((y = o(v, g, d.value, n)) === a || y === f) return y;
        }).BREAK = a),
        (n.RETURN = f);
    },
    function (t, n) {
      var e = 0,
        r = Math.random();
      t.exports = function (t) {
        return "Symbol(".concat(
          void 0 === t ? "" : t,
          ")_",
          (++e + r).toString(36)
        );
      };
    },
    function (t, n) {
      t.exports = function (t, n) {
        return {
          enumerable: !(1 & t),
          configurable: !(2 & t),
          writable: !(4 & t),
          value: n,
        };
      };
    },
    function (t, n, e) {
      var r = e(31),
        o = e(28);
      t.exports = function (t) {
        return r(o(t));
      };
    },
    function (t, n, e) {
      var r = e(27),
        o = Math.min;
      t.exports = function (t) {
        return t > 0 ? o(r(t), 9007199254740991) : 0;
      };
    },
    function (t, n, e) {
      var r = e(28);
      t.exports = function (t) {
        return Object(r(t));
      };
    },
    function (t, n, e) {
      var r = e(16)("meta"),
        o = e(1),
        i = e(9),
        u = e(7).f,
        c = 0,
        s =
          Object.isExtensible ||
          function () {
            return !0;
          },
        a = !e(13)(function () {
          return s(Object.preventExtensions({}));
        }),
        f = function (t) {
          u(t, r, { value: { i: "O" + ++c, w: {} } });
        },
        l = (t.exports = {
          KEY: r,
          NEED: !1,
          fastKey: function (t, n) {
            if (!o(t))
              return "symbol" == typeof t
                ? t
                : ("string" == typeof t ? "S" : "P") + t;
            if (!i(t, r)) {
              if (!s(t)) return "F";
              if (!n) return "E";
              f(t);
            }
            return t[r].i;
          },
          getWeak: function (t, n) {
            if (!i(t, r)) {
              if (!s(t)) return !0;
              if (!n) return !1;
              f(t);
            }
            return t[r].w;
          },
          onFreeze: function (t) {
            return a && l.NEED && s(t) && !i(t, r) && f(t), t;
          },
        });
    },
    function (t, n, e) {
      "use strict";
      var r = e(23),
        o = {};
      (o[e(0)("toStringTag")] = "z"),
        o + "" != "[object z]" &&
          e(6)(
            Object.prototype,
            "toString",
            function () {
              return "[object " + r(this) + "]";
            },
            !0
          );
    },
    function (t, n, e) {
      var r = e(24),
        o = e(0)("toStringTag"),
        i =
          "Arguments" ==
          r(
            (function () {
              return arguments;
            })()
          );
      t.exports = function (t) {
        var n, e, u;
        return void 0 === t
          ? "Undefined"
          : null === t
          ? "Null"
          : "string" ==
            typeof (e = (function (t, n) {
              try {
                return t[n];
              } catch (t) {}
            })((n = Object(t)), o))
          ? e
          : i
          ? r(n)
          : "Object" == (u = r(n)) && "function" == typeof n.callee
          ? "Arguments"
          : u;
      };
    },
    function (t, n) {
      var e = {}.toString;
      t.exports = function (t) {
        return e.call(t).slice(8, -1);
      };
    },
    function (t, n, e) {
      var r = e(3),
        o = e(2),
        i = o["__core-js_shared__"] || (o["__core-js_shared__"] = {});
      (t.exports = function (t, n) {
        return i[t] || (i[t] = void 0 !== n ? n : {});
      })("versions", []).push({
        version: r.version,
        mode: e(40) ? "pure" : "global",
        copyright: "Â© 2019 Denis Pushkarev (zloirock.ru)",
      });
    },
    function (t, n, e) {
      "use strict";
      var r = e(61)(!0);
      e(29)(
        String,
        "String",
        function (t) {
          (this._t = String(t)), (this._i = 0);
        },
        function () {
          var t,
            n = this._t,
            e = this._i;
          return e >= n.length
            ? { value: void 0, done: !0 }
            : ((t = r(n, e)), (this._i += t.length), { value: t, done: !1 });
        }
      );
    },
    function (t, n) {
      var e = Math.ceil,
        r = Math.floor;
      t.exports = function (t) {
        return isNaN((t = +t)) ? 0 : (t > 0 ? r : e)(t);
      };
    },
    function (t, n) {
      t.exports = function (t) {
        if (null == t) throw TypeError("Can't call method on  " + t);
        return t;
      };
    },
    function (t, n, e) {
      "use strict";
      var r = e(40),
        o = e(5),
        i = e(6),
        u = e(11),
        c = e(14),
        s = e(62),
        a = e(33),
        f = e(68),
        l = e(0)("iterator"),
        p = !([].keys && "next" in [].keys()),
        h = function () {
          return this;
        };
      t.exports = function (t, n, e, d, v, y, m) {
        s(e, n, d);
        var g,
          b,
          x,
          _ = function (t) {
            if (!p && t in O) return O[t];
            switch (t) {
              case "keys":
              case "values":
                return function () {
                  return new e(this, t);
                };
            }
            return function () {
              return new e(this, t);
            };
          },
          w = n + " Iterator",
          S = "values" == v,
          E = !1,
          O = t.prototype,
          T = O[l] || O["@@iterator"] || (v && O[v]),
          A = T || _(v),
          M = v ? (S ? _("entries") : A) : void 0,
          P = ("Array" == n && O.entries) || T;
        if (
          (P &&
            (x = f(P.call(new t()))) !== Object.prototype &&
            x.next &&
            (a(x, w, !0), r || "function" == typeof x[l] || u(x, l, h)),
          S &&
            T &&
            "values" !== T.name &&
            ((E = !0),
            (A = function () {
              return T.call(this);
            })),
          (r && !m) || (!p && !E && O[l]) || u(O, l, A),
          (c[n] = A),
          (c[w] = h),
          v)
        )
          if (
            ((g = {
              values: S ? A : _("values"),
              keys: y ? A : _("keys"),
              entries: M,
            }),
            m)
          )
            for (b in g) b in O || i(O, b, g[b]);
          else o(o.P + o.F * (p || E), n, g);
        return g;
      };
    },
    function (t, n, e) {
      var r = e(64),
        o = e(46);
      t.exports =
        Object.keys ||
        function (t) {
          return r(t, o);
        };
    },
    function (t, n, e) {
      var r = e(24);
      t.exports = Object("z").propertyIsEnumerable(0)
        ? Object
        : function (t) {
            return "String" == r(t) ? t.split("") : Object(t);
          };
    },
    function (t, n, e) {
      var r = e(25)("keys"),
        o = e(16);
      t.exports = function (t) {
        return r[t] || (r[t] = o(t));
      };
    },
    function (t, n, e) {
      var r = e(7).f,
        o = e(9),
        i = e(0)("toStringTag");
      t.exports = function (t, n, e) {
        t &&
          !o((t = e ? t : t.prototype), i) &&
          r(t, i, { configurable: !0, value: n });
      };
    },
    function (t, n, e) {
      for (
        var r = e(69),
          o = e(30),
          i = e(6),
          u = e(2),
          c = e(11),
          s = e(14),
          a = e(0),
          f = a("iterator"),
          l = a("toStringTag"),
          p = s.Array,
          h = {
            CSSRuleList: !0,
            CSSStyleDeclaration: !1,
            CSSValueList: !1,
            ClientRectList: !1,
            DOMRectList: !1,
            DOMStringList: !1,
            DOMTokenList: !0,
            DataTransferItemList: !1,
            FileList: !1,
            HTMLAllCollection: !1,
            HTMLCollection: !1,
            HTMLFormElement: !1,
            HTMLSelectElement: !1,
            MediaList: !0,
            MimeTypeArray: !1,
            NamedNodeMap: !1,
            NodeList: !0,
            PaintRequestList: !1,
            Plugin: !1,
            PluginArray: !1,
            SVGLengthList: !1,
            SVGNumberList: !1,
            SVGPathSegList: !1,
            SVGPointList: !1,
            SVGStringList: !1,
            SVGTransformList: !1,
            SourceBufferList: !1,
            StyleSheetList: !0,
            TextTrackCueList: !1,
            TextTrackList: !1,
            TouchList: !1,
          },
          d = o(h),
          v = 0;
        v < d.length;
        v++
      ) {
        var y,
          m = d[v],
          g = h[m],
          b = u[m],
          x = b && b.prototype;
        if (x && (x[f] || c(x, f, p), x[l] || c(x, l, m), (s[m] = p), g))
          for (y in r) x[y] || i(x, y, r[y], !0);
      }
    },
    function (t, n, e) {
      var r = e(6);
      t.exports = function (t, n, e) {
        for (var o in n) r(t, o, n[o], e);
        return t;
      };
    },
    function (t, n) {
      t.exports = function (t, n, e, r) {
        if (!(t instanceof n) || (void 0 !== r && r in t))
          throw TypeError(e + ": incorrect invocation!");
        return t;
      };
    },
    function (t, n, e) {
      "use strict";
      var r = e(2),
        o = e(5),
        i = e(6),
        u = e(35),
        c = e(21),
        s = e(15),
        a = e(36),
        f = e(1),
        l = e(13),
        p = e(52),
        h = e(33),
        d = e(73);
      t.exports = function (t, n, e, v, y, m) {
        var g = r[t],
          b = g,
          x = y ? "set" : "add",
          _ = b && b.prototype,
          w = {},
          S = function (t) {
            var n = _[t];
            i(
              _,
              t,
              "delete" == t
                ? function (t) {
                    return !(m && !f(t)) && n.call(this, 0 === t ? 0 : t);
                  }
                : "has" == t
                ? function (t) {
                    return !(m && !f(t)) && n.call(this, 0 === t ? 0 : t);
                  }
                : "get" == t
                ? function (t) {
                    return m && !f(t) ? void 0 : n.call(this, 0 === t ? 0 : t);
                  }
                : "add" == t
                ? function (t) {
                    return n.call(this, 0 === t ? 0 : t), this;
                  }
                : function (t, e) {
                    return n.call(this, 0 === t ? 0 : t, e), this;
                  }
            );
          };
        if (
          "function" == typeof b &&
          (m ||
            (_.forEach &&
              !l(function () {
                new b().entries().next();
              })))
        ) {
          var E = new b(),
            O = E[x](m ? {} : -0, 1) != E,
            T = l(function () {
              E.has(1);
            }),
            A = p(function (t) {
              new b(t);
            }),
            M =
              !m &&
              l(function () {
                for (var t = new b(), n = 5; n--; ) t[x](n, n);
                return !t.has(-0);
              });
          A ||
            (((b = n(function (n, e) {
              a(n, b, t);
              var r = d(new g(), n, b);
              return null != e && s(e, y, r[x], r), r;
            })).prototype = _),
            (_.constructor = b)),
            (T || M) && (S("delete"), S("has"), y && S("get")),
            (M || O) && S(x),
            m && _.clear && delete _.clear;
        } else
          (b = v.getConstructor(n, t, y, x)), u(b.prototype, e), (c.NEED = !0);
        return (
          h(b, t),
          (w[t] = b),
          o(o.G + o.W + o.F * (b != g), w),
          m || v.setStrong(b, t, y),
          b
        );
      };
    },
    function (t, n, e) {
      "use strict";
      var r = e(5);
      t.exports = function (t) {
        r(r.S, t, {
          of: function () {
            for (var t = arguments.length, n = new Array(t); t--; )
              n[t] = arguments[t];
            return new this(n);
          },
        });
      };
    },
    function (t, n, e) {
      "use strict";
      var r = e(5),
        o = e(44),
        i = e(10),
        u = e(15);
      t.exports = function (t) {
        r(r.S, t, {
          from: function (t) {
            var n,
              e,
              r,
              c,
              s = arguments[1];
            return (
              o(this),
              (n = void 0 !== s) && o(s),
              null == t
                ? new this()
                : ((e = []),
                  n
                    ? ((r = 0),
                      (c = i(s, arguments[2], 2)),
                      u(t, !1, function (t) {
                        e.push(c(t, r++));
                      }))
                    : u(t, !1, e.push, e),
                  new this(e))
            );
          },
        });
      };
    },
    function (t, n) {
      t.exports = !1;
    },
    function (t, n, e) {
      t.exports =
        !e(4) &&
        !e(13)(function () {
          return (
            7 !=
            Object.defineProperty(e(42)("div"), "a", {
              get: function () {
                return 7;
              },
            }).a
          );
        });
    },
    function (t, n, e) {
      var r = e(1),
        o = e(2).document,
        i = r(o) && r(o.createElement);
      t.exports = function (t) {
        return i ? o.createElement(t) : {};
      };
    },
    function (t, n, e) {
      var r = e(1);
      t.exports = function (t, n) {
        if (!r(t)) return t;
        var e, o;
        if (n && "function" == typeof (e = t.toString) && !r((o = e.call(t))))
          return o;
        if ("function" == typeof (e = t.valueOf) && !r((o = e.call(t))))
          return o;
        if (!n && "function" == typeof (e = t.toString) && !r((o = e.call(t))))
          return o;
        throw TypeError("Can't convert object to primitive value");
      };
    },
    function (t, n) {
      t.exports = function (t) {
        if ("function" != typeof t) throw TypeError(t + " is not a function!");
        return t;
      };
    },
    function (t, n, e) {
      var r = e(8),
        o = e(63),
        i = e(46),
        u = e(32)("IE_PROTO"),
        c = function () {},
        s = function () {
          var t,
            n = e(42)("iframe"),
            r = i.length;
          for (
            n.style.display = "none",
              e(67).appendChild(n),
              n.src = "javascript:",
              (t = n.contentWindow.document).open(),
              t.write("<script>document.F=Object</script>"),
              t.close(),
              s = t.F;
            r--;

          )
            delete s.prototype[i[r]];
          return s();
        };
      t.exports =
        Object.create ||
        function (t, n) {
          var e;
          return (
            null !== t
              ? ((c.prototype = r(t)),
                (e = new c()),
                (c.prototype = null),
                (e[u] = t))
              : (e = s()),
            void 0 === n ? e : o(e, n)
          );
        };
    },
    function (t, n) {
      t.exports =
        "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(
          ","
        );
    },
    function (t, n) {
      t.exports = function (t, n) {
        return { value: n, done: !!t };
      };
    },
    function (t, n, e) {
      "use strict";
      var r = e(7).f,
        o = e(45),
        i = e(35),
        u = e(10),
        c = e(36),
        s = e(15),
        a = e(29),
        f = e(47),
        l = e(72),
        p = e(4),
        h = e(21).fastKey,
        d = e(12),
        v = p ? "_s" : "size",
        y = function (t, n) {
          var e,
            r = h(n);
          if ("F" !== r) return t._i[r];
          for (e = t._f; e; e = e.n) if (e.k == n) return e;
        };
      t.exports = {
        getConstructor: function (t, n, e, a) {
          var f = t(function (t, r) {
            c(t, f, n, "_i"),
              (t._t = n),
              (t._i = o(null)),
              (t._f = void 0),
              (t._l = void 0),
              (t[v] = 0),
              null != r && s(r, e, t[a], t);
          });
          return (
            i(f.prototype, {
              clear: function () {
                for (var t = d(this, n), e = t._i, r = t._f; r; r = r.n)
                  (r.r = !0), r.p && (r.p = r.p.n = void 0), delete e[r.i];
                (t._f = t._l = void 0), (t[v] = 0);
              },
              delete: function (t) {
                var e = d(this, n),
                  r = y(e, t);
                if (r) {
                  var o = r.n,
                    i = r.p;
                  delete e._i[r.i],
                    (r.r = !0),
                    i && (i.n = o),
                    o && (o.p = i),
                    e._f == r && (e._f = o),
                    e._l == r && (e._l = i),
                    e[v]--;
                }
                return !!r;
              },
              forEach: function (t) {
                d(this, n);
                for (
                  var e,
                    r = u(t, arguments.length > 1 ? arguments[1] : void 0, 3);
                  (e = e ? e.n : this._f);

                )
                  for (r(e.v, e.k, this); e && e.r; ) e = e.p;
              },
              has: function (t) {
                return !!y(d(this, n), t);
              },
            }),
            p &&
              r(f.prototype, "size", {
                get: function () {
                  return d(this, n)[v];
                },
              }),
            f
          );
        },
        def: function (t, n, e) {
          var r,
            o,
            i = y(t, n);
          return (
            i
              ? (i.v = e)
              : ((t._l = i =
                  {
                    i: (o = h(n, !0)),
                    k: n,
                    v: e,
                    p: (r = t._l),
                    n: void 0,
                    r: !1,
                  }),
                t._f || (t._f = i),
                r && (r.n = i),
                t[v]++,
                "F" !== o && (t._i[o] = i)),
            t
          );
        },
        getEntry: y,
        setStrong: function (t, n, e) {
          a(
            t,
            n,
            function (t, e) {
              (this._t = d(t, n)), (this._k = e), (this._l = void 0);
            },
            function () {
              for (var t = this._k, n = this._l; n && n.r; ) n = n.p;
              return this._t && (this._l = n = n ? n.n : this._t._f)
                ? f(0, "keys" == t ? n.k : "values" == t ? n.v : [n.k, n.v])
                : ((this._t = void 0), f(1));
            },
            e ? "entries" : "values",
            !e,
            !0
          ),
            l(n);
        },
      };
    },
    function (t, n, e) {
      var r = e(8);
      t.exports = function (t, n, e, o) {
        try {
          return o ? n(r(e)[0], e[1]) : n(e);
        } catch (n) {
          var i = t.return;
          throw (void 0 !== i && r(i.call(t)), n);
        }
      };
    },
    function (t, n, e) {
      var r = e(14),
        o = e(0)("iterator"),
        i = Array.prototype;
      t.exports = function (t) {
        return void 0 !== t && (r.Array === t || i[o] === t);
      };
    },
    function (t, n, e) {
      var r = e(23),
        o = e(0)("iterator"),
        i = e(14);
      t.exports = e(3).getIteratorMethod = function (t) {
        if (null != t) return t[o] || t["@@iterator"] || i[r(t)];
      };
    },
    function (t, n, e) {
      var r = e(0)("iterator"),
        o = !1;
      try {
        var i = [7][r]();
        (i.return = function () {
          o = !0;
        }),
          Array.from(i, function () {
            throw 2;
          });
      } catch (t) {}
      t.exports = function (t, n) {
        if (!n && !o) return !1;
        var e = !1;
        try {
          var i = [7],
            u = i[r]();
          (u.next = function () {
            return { done: (e = !0) };
          }),
            (i[r] = function () {
              return u;
            }),
            t(i);
        } catch (t) {}
        return e;
      };
    },
    function (t, n) {
      n.f = {}.propertyIsEnumerable;
    },
    function (t, n, e) {
      var r = e(23),
        o = e(77);
      t.exports = function (t) {
        return function () {
          if (r(this) != t) throw TypeError(t + "#toJSON isn't generic");
          return o(this);
        };
      };
    },
    function (t, n, e) {
      var r = e(10),
        o = e(31),
        i = e(20),
        u = e(19),
        c = e(87);
      t.exports = function (t, n) {
        var e = 1 == t,
          s = 2 == t,
          a = 3 == t,
          f = 4 == t,
          l = 6 == t,
          p = 5 == t || l,
          h = n || c;
        return function (n, c, d) {
          for (
            var v,
              y,
              m = i(n),
              g = o(m),
              b = r(c, d, 3),
              x = u(g.length),
              _ = 0,
              w = e ? h(n, x) : s ? h(n, 0) : void 0;
            x > _;
            _++
          )
            if ((p || _ in g) && ((y = b((v = g[_]), _, m)), t))
              if (e) w[_] = y;
              else if (y)
                switch (t) {
                  case 3:
                    return !0;
                  case 5:
                    return v;
                  case 6:
                    return _;
                  case 2:
                    w.push(v);
                }
              else if (f) return !1;
          return l ? -1 : a || f ? f : w;
        };
      };
    },
    function (t, n, e) {
      "use strict";
      var r = e(4),
        o = e(30),
        i = e(90),
        u = e(53),
        c = e(20),
        s = e(31),
        a = Object.assign;
      t.exports =
        !a ||
        e(13)(function () {
          var t = {},
            n = {},
            e = Symbol(),
            r = "abcdefghijklmnopqrst";
          return (
            (t[e] = 7),
            r.split("").forEach(function (t) {
              n[t] = t;
            }),
            7 != a({}, t)[e] || Object.keys(a({}, n)).join("") != r
          );
        })
          ? function (t, n) {
              for (
                var e = c(t), a = arguments.length, f = 1, l = i.f, p = u.f;
                a > f;

              )
                for (
                  var h,
                    d = s(arguments[f++]),
                    v = l ? o(d).concat(l(d)) : o(d),
                    y = v.length,
                    m = 0;
                  y > m;

                )
                  (h = v[m++]), (r && !p.call(d, h)) || (e[h] = d[h]);
              return e;
            }
          : a;
    },
    function (t, n, e) {
      "use strict";
      (function (t) {
        var e = "object" == typeof t && t && t.Object === Object && t;
        n.a = e;
      }).call(this, e(99));
    },
    function (t, n, e) {
      t.exports = e(100);
    },
    function (t, n, e) {
      e(22), e(26), e(34), e(71), e(76), e(78), e(79), (t.exports = e(3).Map);
    },
    function (t, n, e) {
      t.exports = e(25)("native-function-to-string", Function.toString);
    },
    function (t, n, e) {
      var r = e(27),
        o = e(28);
      t.exports = function (t) {
        return function (n, e) {
          var i,
            u,
            c = String(o(n)),
            s = r(e),
            a = c.length;
          return s < 0 || s >= a
            ? t
              ? ""
              : void 0
            : (i = c.charCodeAt(s)) < 55296 ||
              i > 56319 ||
              s + 1 === a ||
              (u = c.charCodeAt(s + 1)) < 56320 ||
              u > 57343
            ? t
              ? c.charAt(s)
              : i
            : t
            ? c.slice(s, s + 2)
            : u - 56320 + ((i - 55296) << 10) + 65536;
        };
      };
    },
    function (t, n, e) {
      "use strict";
      var r = e(45),
        o = e(17),
        i = e(33),
        u = {};
      e(11)(u, e(0)("iterator"), function () {
        return this;
      }),
        (t.exports = function (t, n, e) {
          (t.prototype = r(u, { next: o(1, e) })), i(t, n + " Iterator");
        });
    },
    function (t, n, e) {
      var r = e(7),
        o = e(8),
        i = e(30);
      t.exports = e(4)
        ? Object.defineProperties
        : function (t, n) {
            o(t);
            for (var e, u = i(n), c = u.length, s = 0; c > s; )
              r.f(t, (e = u[s++]), n[e]);
            return t;
          };
    },
    function (t, n, e) {
      var r = e(9),
        o = e(18),
        i = e(65)(!1),
        u = e(32)("IE_PROTO");
      t.exports = function (t, n) {
        var e,
          c = o(t),
          s = 0,
          a = [];
        for (e in c) e != u && r(c, e) && a.push(e);
        for (; n.length > s; ) r(c, (e = n[s++])) && (~i(a, e) || a.push(e));
        return a;
      };
    },
    function (t, n, e) {
      var r = e(18),
        o = e(19),
        i = e(66);
      t.exports = function (t) {
        return function (n, e, u) {
          var c,
            s = r(n),
            a = o(s.length),
            f = i(u, a);
          if (t && e != e) {
            for (; a > f; ) if ((c = s[f++]) != c) return !0;
          } else
            for (; a > f; f++)
              if ((t || f in s) && s[f] === e) return t || f || 0;
          return !t && -1;
        };
      };
    },
    function (t, n, e) {
      var r = e(27),
        o = Math.max,
        i = Math.min;
      t.exports = function (t, n) {
        return (t = r(t)) < 0 ? o(t + n, 0) : i(t, n);
      };
    },
    function (t, n, e) {
      var r = e(2).document;
      t.exports = r && r.documentElement;
    },
    function (t, n, e) {
      var r = e(9),
        o = e(20),
        i = e(32)("IE_PROTO"),
        u = Object.prototype;
      t.exports =
        Object.getPrototypeOf ||
        function (t) {
          return (
            (t = o(t)),
            r(t, i)
              ? t[i]
              : "function" == typeof t.constructor && t instanceof t.constructor
              ? t.constructor.prototype
              : t instanceof Object
              ? u
              : null
          );
        };
    },
    function (t, n, e) {
      "use strict";
      var r = e(70),
        o = e(47),
        i = e(14),
        u = e(18);
      (t.exports = e(29)(
        Array,
        "Array",
        function (t, n) {
          (this._t = u(t)), (this._i = 0), (this._k = n);
        },
        function () {
          var t = this._t,
            n = this._k,
            e = this._i++;
          return !t || e >= t.length
            ? ((this._t = void 0), o(1))
            : o(0, "keys" == n ? e : "values" == n ? t[e] : [e, t[e]]);
        },
        "values"
      )),
        (i.Arguments = i.Array),
        r("keys"),
        r("values"),
        r("entries");
    },
    function (t, n, e) {
      var r = e(0)("unscopables"),
        o = Array.prototype;
      null == o[r] && e(11)(o, r, {}),
        (t.exports = function (t) {
          o[r][t] = !0;
        });
    },
    function (t, n, e) {
      "use strict";
      var r = e(48),
        o = e(12);
      t.exports = e(37)(
        "Map",
        function (t) {
          return function () {
            return t(this, arguments.length > 0 ? arguments[0] : void 0);
          };
        },
        {
          get: function (t) {
            var n = r.getEntry(o(this, "Map"), t);
            return n && n.v;
          },
          set: function (t, n) {
            return r.def(o(this, "Map"), 0 === t ? 0 : t, n);
          },
        },
        r,
        !0
      );
    },
    function (t, n, e) {
      "use strict";
      var r = e(2),
        o = e(7),
        i = e(4),
        u = e(0)("species");
      t.exports = function (t) {
        var n = r[t];
        i &&
          n &&
          !n[u] &&
          o.f(n, u, {
            configurable: !0,
            get: function () {
              return this;
            },
          });
      };
    },
    function (t, n, e) {
      var r = e(1),
        o = e(74).set;
      t.exports = function (t, n, e) {
        var i,
          u = n.constructor;
        return (
          u !== e &&
            "function" == typeof u &&
            (i = u.prototype) !== e.prototype &&
            r(i) &&
            o &&
            o(t, i),
          t
        );
      };
    },
    function (t, n, e) {
      var r = e(1),
        o = e(8),
        i = function (t, n) {
          if ((o(t), !r(n) && null !== n))
            throw TypeError(n + ": can't set as prototype!");
        };
      t.exports = {
        set:
          Object.setPrototypeOf ||
          ("__proto__" in {}
            ? (function (t, n, r) {
                try {
                  (r = e(10)(
                    Function.call,
                    e(75).f(Object.prototype, "__proto__").set,
                    2
                  ))(t, []),
                    (n = !(t instanceof Array));
                } catch (t) {
                  n = !0;
                }
                return function (t, e) {
                  return i(t, e), n ? (t.__proto__ = e) : r(t, e), t;
                };
              })({}, !1)
            : void 0),
        check: i,
      };
    },
    function (t, n, e) {
      var r = e(53),
        o = e(17),
        i = e(18),
        u = e(43),
        c = e(9),
        s = e(41),
        a = Object.getOwnPropertyDescriptor;
      n.f = e(4)
        ? a
        : function (t, n) {
            if (((t = i(t)), (n = u(n, !0)), s))
              try {
                return a(t, n);
              } catch (t) {}
            if (c(t, n)) return o(!r.f.call(t, n), t[n]);
          };
    },
    function (t, n, e) {
      var r = e(5);
      r(r.P + r.R, "Map", { toJSON: e(54)("Map") });
    },
    function (t, n, e) {
      var r = e(15);
      t.exports = function (t, n) {
        var e = [];
        return r(t, !1, e.push, e, n), e;
      };
    },
    function (t, n, e) {
      e(38)("Map");
    },
    function (t, n, e) {
      e(39)("Map");
    },
    function (t, n, e) {
      e(22), e(26), e(34), e(81), e(82), e(83), e(84), (t.exports = e(3).Set);
    },
    function (t, n, e) {
      "use strict";
      var r = e(48),
        o = e(12);
      t.exports = e(37)(
        "Set",
        function (t) {
          return function () {
            return t(this, arguments.length > 0 ? arguments[0] : void 0);
          };
        },
        {
          add: function (t) {
            return r.def(o(this, "Set"), (t = 0 === t ? 0 : t), t);
          },
        },
        r
      );
    },
    function (t, n, e) {
      var r = e(5);
      r(r.P + r.R, "Set", { toJSON: e(54)("Set") });
    },
    function (t, n, e) {
      e(38)("Set");
    },
    function (t, n, e) {
      e(39)("Set");
    },
    function (t, n, e) {
      e(22), e(34), e(86), e(92), e(93), (t.exports = e(3).WeakMap);
    },
    function (t, n, e) {
      "use strict";
      var r,
        o = e(2),
        i = e(55)(0),
        u = e(6),
        c = e(21),
        s = e(56),
        a = e(91),
        f = e(1),
        l = e(12),
        p = e(12),
        h = !o.ActiveXObject && "ActiveXObject" in o,
        d = c.getWeak,
        v = Object.isExtensible,
        y = a.ufstore,
        m = function (t) {
          return function () {
            return t(this, arguments.length > 0 ? arguments[0] : void 0);
          };
        },
        g = {
          get: function (t) {
            if (f(t)) {
              var n = d(t);
              return !0 === n
                ? y(l(this, "WeakMap")).get(t)
                : n
                ? n[this._i]
                : void 0;
            }
          },
          set: function (t, n) {
            return a.def(l(this, "WeakMap"), t, n);
          },
        },
        b = (t.exports = e(37)("WeakMap", m, g, a, !0, !0));
      p &&
        h &&
        (s((r = a.getConstructor(m, "WeakMap")).prototype, g),
        (c.NEED = !0),
        i(["delete", "has", "get", "set"], function (t) {
          var n = b.prototype,
            e = n[t];
          u(n, t, function (n, o) {
            if (f(n) && !v(n)) {
              this._f || (this._f = new r());
              var i = this._f[t](n, o);
              return "set" == t ? this : i;
            }
            return e.call(this, n, o);
          });
        }));
    },
    function (t, n, e) {
      var r = e(88);
      t.exports = function (t, n) {
        return new (r(t))(n);
      };
    },
    function (t, n, e) {
      var r = e(1),
        o = e(89),
        i = e(0)("species");
      t.exports = function (t) {
        var n;
        return (
          o(t) &&
            ("function" != typeof (n = t.constructor) ||
              (n !== Array && !o(n.prototype)) ||
              (n = void 0),
            r(n) && null === (n = n[i]) && (n = void 0)),
          void 0 === n ? Array : n
        );
      };
    },
    function (t, n, e) {
      var r = e(24);
      t.exports =
        Array.isArray ||
        function (t) {
          return "Array" == r(t);
        };
    },
    function (t, n) {
      n.f = Object.getOwnPropertySymbols;
    },
    function (t, n, e) {
      "use strict";
      var r = e(35),
        o = e(21).getWeak,
        i = e(8),
        u = e(1),
        c = e(36),
        s = e(15),
        a = e(55),
        f = e(9),
        l = e(12),
        p = a(5),
        h = a(6),
        d = 0,
        v = function (t) {
          return t._l || (t._l = new y());
        },
        y = function () {
          this.a = [];
        },
        m = function (t, n) {
          return p(t.a, function (t) {
            return t[0] === n;
          });
        };
      (y.prototype = {
        get: function (t) {
          var n = m(this, t);
          if (n) return n[1];
        },
        has: function (t) {
          return !!m(this, t);
        },
        set: function (t, n) {
          var e = m(this, t);
          e ? (e[1] = n) : this.a.push([t, n]);
        },
        delete: function (t) {
          var n = h(this.a, function (n) {
            return n[0] === t;
          });
          return ~n && this.a.splice(n, 1), !!~n;
        },
      }),
        (t.exports = {
          getConstructor: function (t, n, e, i) {
            var a = t(function (t, r) {
              c(t, a, n, "_i"),
                (t._t = n),
                (t._i = d++),
                (t._l = void 0),
                null != r && s(r, e, t[i], t);
            });
            return (
              r(a.prototype, {
                delete: function (t) {
                  if (!u(t)) return !1;
                  var e = o(t);
                  return !0 === e
                    ? v(l(this, n)).delete(t)
                    : e && f(e, this._i) && delete e[this._i];
                },
                has: function (t) {
                  if (!u(t)) return !1;
                  var e = o(t);
                  return !0 === e ? v(l(this, n)).has(t) : e && f(e, this._i);
                },
              }),
              a
            );
          },
          def: function (t, n, e) {
            var r = o(i(n), !0);
            return !0 === r ? v(t).set(n, e) : (r[t._i] = e), t;
          },
          ufstore: v,
        });
    },
    function (t, n, e) {
      e(38)("WeakMap");
    },
    function (t, n, e) {
      e(39)("WeakMap");
    },
    function (t, n, e) {
      e(26), e(95), (t.exports = e(3).Array.from);
    },
    function (t, n, e) {
      "use strict";
      var r = e(10),
        o = e(5),
        i = e(20),
        u = e(49),
        c = e(50),
        s = e(19),
        a = e(96),
        f = e(51);
      o(
        o.S +
          o.F *
            !e(52)(function (t) {
              Array.from(t);
            }),
        "Array",
        {
          from: function (t) {
            var n,
              e,
              o,
              l,
              p = i(t),
              h = "function" == typeof this ? this : Array,
              d = arguments.length,
              v = d > 1 ? arguments[1] : void 0,
              y = void 0 !== v,
              m = 0,
              g = f(p);
            if (
              (y && (v = r(v, d > 2 ? arguments[2] : void 0, 2)),
              null == g || (h == Array && c(g)))
            )
              for (e = new h((n = s(p.length))); n > m; m++)
                a(e, m, y ? v(p[m], m) : p[m]);
            else
              for (l = g.call(p), e = new h(); !(o = l.next()).done; m++)
                a(e, m, y ? u(l, v, [o.value, m], !0) : o.value);
            return (e.length = m), e;
          },
        }
      );
    },
    function (t, n, e) {
      "use strict";
      var r = e(7),
        o = e(17);
      t.exports = function (t, n, e) {
        n in t ? r.f(t, n, o(0, e)) : (t[n] = e);
      };
    },
    function (t, n, e) {
      e(98), (t.exports = e(3).Object.assign);
    },
    function (t, n, e) {
      var r = e(5);
      r(r.S + r.F, "Object", { assign: e(56) });
    },
    function (t, n) {
      var e;
      e = (function () {
        return this;
      })();
      try {
        e = e || new Function("return this")();
      } catch (t) {
        "object" == typeof window && (e = window);
      }
      t.exports = e;
    },
    function (t, n, e) {
      "use strict";
      e.r(n);
      var r = {};
      e.r(r),
        e.d(r, "keyboardHandler", function () {
          return et;
        }),
        e.d(r, "mouseHandler", function () {
          return rt;
        }),
        e.d(r, "resizeHandler", function () {
          return ot;
        }),
        e.d(r, "selectHandler", function () {
          return it;
        }),
        e.d(r, "touchHandler", function () {
          return ut;
        }),
        e.d(r, "wheelHandler", function () {
          return ct;
        });
      /*! *****************************************************************************
Copyright (c) Microsoft Corporation. All rights reserved.
Licensed under the Apache License, Version 2.0 (the "License"); you may not use
this file except in compliance with the License. You may obtain a copy of the
License at http://www.apache.org/licenses/LICENSE-2.0

THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
MERCHANTABLITY OR NON-INFRINGEMENT.

See the Apache Version 2.0 License for specific language governing permissions
and limitations under the License.
***************************************************************************** */
      var o = function (t, n) {
          return (o =
            Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array &&
              function (t, n) {
                t.__proto__ = n;
              }) ||
            function (t, n) {
              for (var e in n) n.hasOwnProperty(e) && (t[e] = n[e]);
            })(t, n);
        },
        i = function () {
          return (i =
            Object.assign ||
            function (t) {
              for (var n, e = 1, r = arguments.length; e < r; e++)
                for (var o in (n = arguments[e]))
                  Object.prototype.hasOwnProperty.call(n, o) && (t[o] = n[o]);
              return t;
            }).apply(this, arguments);
        };
      function u(t, n, e, r) {
        var o,
          i = arguments.length,
          u =
            i < 3
              ? n
              : null === r
              ? (r = Object.getOwnPropertyDescriptor(n, e))
              : r;
        if ("object" == typeof Reflect && "function" == typeof Reflect.decorate)
          u = Reflect.decorate(t, n, e, r);
        else
          for (var c = t.length - 1; c >= 0; c--)
            (o = t[c]) &&
              (u = (i < 3 ? o(u) : i > 3 ? o(n, e, u) : o(n, e)) || u);
        return i > 3 && u && Object.defineProperty(n, e, u), u;
      }
      e(59), e(80), e(85), e(94), e(97);
      var c = function (t) {
          var n = typeof t;
          return null != t && ("object" == n || "function" == n);
        },
        s = e(57),
        a = "object" == typeof self && self && self.Object === Object && self,
        f = s.a || a || Function("return this")(),
        l = f.Symbol,
        p = Object.prototype,
        h = p.hasOwnProperty,
        d = p.toString,
        v = l ? l.toStringTag : void 0,
        y = Object.prototype.toString,
        m = l ? l.toStringTag : void 0,
        g = function (t) {
          return null == t
            ? void 0 === t
              ? "[object Undefined]"
              : "[object Null]"
            : m && m in Object(t)
            ? (function (t) {
                var n = h.call(t, v),
                  e = t[v];
                try {
                  t[v] = void 0;
                  var r = !0;
                } catch (t) {}
                var o = d.call(t);
                return r && (n ? (t[v] = e) : delete t[v]), o;
              })(t)
            : (function (t) {
                return y.call(t);
              })(t);
        },
        b = /^\s+|\s+$/g,
        x = /^[-+]0x[0-9a-f]+$/i,
        _ = /^0b[01]+$/i,
        w = /^0o[0-7]+$/i,
        S = parseInt,
        E = function (t) {
          if ("number" == typeof t) return t;
          if (
            (function (t) {
              return (
                "symbol" == typeof t ||
                ((function (t) {
                  return null != t && "object" == typeof t;
                })(t) &&
                  "[object Symbol]" == g(t))
              );
            })(t)
          )
            return NaN;
          if (c(t)) {
            var n = "function" == typeof t.valueOf ? t.valueOf() : t;
            t = c(n) ? n + "" : n;
          }
          if ("string" != typeof t) return 0 === t ? t : +t;
          t = t.replace(b, "");
          var e = _.test(t);
          return e || w.test(t)
            ? S(t.slice(2), e ? 2 : 8)
            : x.test(t)
            ? NaN
            : +t;
        },
        O = function (t, n, e) {
          return (
            void 0 === e && ((e = n), (n = void 0)),
            void 0 !== e && (e = (e = E(e)) == e ? e : 0),
            void 0 !== n && (n = (n = E(n)) == n ? n : 0),
            (function (t, n, e) {
              return (
                t == t &&
                  (void 0 !== e && (t = t <= e ? t : e),
                  void 0 !== n && (t = t >= n ? t : n)),
                t
              );
            })(E(t), n, e)
          );
        };
      function T(t, n) {
        return (
          void 0 === t && (t = -1 / 0),
          void 0 === n && (n = 1 / 0),
          function (e, r) {
            var o = "_" + r;
            Object.defineProperty(e, r, {
              get: function () {
                return this[o];
              },
              set: function (e) {
                Object.defineProperty(this, o, {
                  value: O(e, t, n),
                  enumerable: !1,
                  writable: !0,
                  configurable: !0,
                });
              },
              enumerable: !0,
              configurable: !0,
            });
          }
        );
      }
      function A(t, n) {
        var e = "_" + n;
        Object.defineProperty(t, n, {
          get: function () {
            return this[e];
          },
          set: function (t) {
            Object.defineProperty(this, e, {
              value: !!t,
              enumerable: !1,
              writable: !0,
              configurable: !0,
            });
          },
          enumerable: !0,
          configurable: !0,
        });
      }
      var M = function () {
          return f.Date.now();
        },
        P = Math.max,
        j = Math.min,
        k = function (t, n, e) {
          var r,
            o,
            i,
            u,
            s,
            a,
            f = 0,
            l = !1,
            p = !1,
            h = !0;
          if ("function" != typeof t)
            throw new TypeError("Expected a function");
          function d(n) {
            var e = r,
              i = o;
            return (r = o = void 0), (f = n), (u = t.apply(i, e));
          }
          function v(t) {
            var e = t - a;
            return void 0 === a || e >= n || e < 0 || (p && t - f >= i);
          }
          function y() {
            var t = M();
            if (v(t)) return m(t);
            s = setTimeout(
              y,
              (function (t) {
                var e = n - (t - a);
                return p ? j(e, i - (t - f)) : e;
              })(t)
            );
          }
          function m(t) {
            return (s = void 0), h && r ? d(t) : ((r = o = void 0), u);
          }
          function g() {
            var t = M(),
              e = v(t);
            if (((r = arguments), (o = this), (a = t), e)) {
              if (void 0 === s)
                return (function (t) {
                  return (f = t), (s = setTimeout(y, n)), l ? d(t) : u;
                })(a);
              if (p) return clearTimeout(s), (s = setTimeout(y, n)), d(a);
            }
            return void 0 === s && (s = setTimeout(y, n)), u;
          }
          return (
            (n = E(n) || 0),
            c(e) &&
              ((l = !!e.leading),
              (i = (p = "maxWait" in e) ? P(E(e.maxWait) || 0, n) : i),
              (h = "trailing" in e ? !!e.trailing : h)),
            (g.cancel = function () {
              void 0 !== s && clearTimeout(s),
                (f = 0),
                (r = a = o = s = void 0);
            }),
            (g.flush = function () {
              return void 0 === s ? u : m(M());
            }),
            g
          );
        };
      function D() {
        for (var t = [], n = 0; n < arguments.length; n++) t[n] = arguments[n];
        return function (n, e, r) {
          var o = r.value;
          return {
            get: function () {
              return (
                this.hasOwnProperty(e) ||
                  Object.defineProperty(this, e, {
                    value: k.apply(
                      void 0,
                      (function () {
                        for (var t = 0, n = 0, e = arguments.length; n < e; n++)
                          t += arguments[n].length;
                        var r = Array(t),
                          o = 0;
                        for (n = 0; n < e; n++)
                          for (
                            var i = arguments[n], u = 0, c = i.length;
                            u < c;
                            u++, o++
                          )
                            r[o] = i[u];
                        return r;
                      })([o], t)
                    ),
                  }),
                this[e]
              );
            },
          };
        };
      }
      var L,
        N = (function () {
          function t(t) {
            var n = this;
            void 0 === t && (t = {}),
              (this.damping = 0.1),
              (this.thumbMinSize = 20),
              (this.renderByPixels = !0),
              (this.alwaysShowTracks = !1),
              (this.continuousScrolling = !0),
              (this.delegateTo = null),
              (this.plugins = {}),
              Object.keys(t).forEach(function (e) {
                n[e] = t[e];
              });
          }
          return (
            Object.defineProperty(t.prototype, "wheelEventTarget", {
              get: function () {
                return this.delegateTo;
              },
              set: function (t) {
                console.warn(
                  "[smooth-scrollbar]: `options.wheelEventTarget` is deprecated and will be removed in the future, use `options.delegateTo` instead."
                ),
                  (this.delegateTo = t);
              },
              enumerable: !0,
              configurable: !0,
            }),
            u([T(0, 1)], t.prototype, "damping", void 0),
            u([T(0, 1 / 0)], t.prototype, "thumbMinSize", void 0),
            u([A], t.prototype, "renderByPixels", void 0),
            u([A], t.prototype, "alwaysShowTracks", void 0),
            u([A], t.prototype, "continuousScrolling", void 0),
            t
          );
        })(),
        z = new WeakMap();
      function C() {
        if (void 0 !== L) return L;
        var t = !1;
        try {
          var n = function () {},
            e = Object.defineProperty({}, "passive", {
              get: function () {
                t = !0;
              },
            });
          window.addEventListener("testPassive", n, e),
            window.removeEventListener("testPassive", n, e);
        } catch (t) {}
        return (L = !!t && { passive: !1 });
      }
      function R(t) {
        var n = z.get(t) || [];
        return (
          z.set(t, n),
          function (t, e, r) {
            function o(t) {
              t.defaultPrevented || r(t);
            }
            e.split(/\s+/g).forEach(function (e) {
              n.push({ elem: t, eventName: e, handler: o }),
                t.addEventListener(e, o, C());
            });
          }
        );
      }
      function F(t) {
        var n = (function (t) {
          return t.touches ? t.touches[t.touches.length - 1] : t;
        })(t);
        return { x: n.clientX, y: n.clientY };
      }
      function I(t, n) {
        return (
          void 0 === n && (n = []),
          n.some(function (n) {
            return t === n;
          })
        );
      }
      var W = ["webkit", "moz", "ms", "o"],
        H = new RegExp("^-(?!(?:" + W.join("|") + ")-)");
      function B(t, n) {
        (n = (function (t) {
          var n = {};
          return (
            Object.keys(t).forEach(function (e) {
              if (H.test(e)) {
                var r = t[e];
                (e = e.replace(/^-/, "")),
                  (n[e] = r),
                  W.forEach(function (t) {
                    n["-" + t + "-" + e] = r;
                  });
              } else n[e] = t[e];
            }),
            n
          );
        })(n)),
          Object.keys(n).forEach(function (e) {
            var r = e.replace(/^-/, "").replace(/-([a-z])/g, function (t, n) {
              return n.toUpperCase();
            });
            t.style[r] = n[e];
          });
      }
      var G,
        X = (function () {
          function t(t) {
            (this.updateTime = Date.now()),
              (this.delta = { x: 0, y: 0 }),
              (this.velocity = { x: 0, y: 0 }),
              (this.lastPosition = { x: 0, y: 0 }),
              (this.lastPosition = F(t));
          }
          return (
            (t.prototype.update = function (t) {
              var n = this.velocity,
                e = this.updateTime,
                r = this.lastPosition,
                o = Date.now(),
                i = F(t),
                u = { x: -(i.x - r.x), y: -(i.y - r.y) },
                c = o - e || 16,
                s = (u.x / c) * 16,
                a = (u.y / c) * 16;
              (n.x = 0.9 * s + 0.1 * n.x),
                (n.y = 0.9 * a + 0.1 * n.y),
                (this.delta = u),
                (this.updateTime = o),
                (this.lastPosition = i);
            }),
            t
          );
        })(),
        V = (function () {
          function t() {
            this._touchList = {};
          }
          return (
            Object.defineProperty(t.prototype, "_primitiveValue", {
              get: function () {
                return { x: 0, y: 0 };
              },
              enumerable: !0,
              configurable: !0,
            }),
            (t.prototype.isActive = function () {
              return void 0 !== this._activeTouchID;
            }),
            (t.prototype.getDelta = function () {
              var t = this._getActiveTracker();
              return t ? i({}, t.delta) : this._primitiveValue;
            }),
            (t.prototype.getVelocity = function () {
              var t = this._getActiveTracker();
              return t ? i({}, t.velocity) : this._primitiveValue;
            }),
            (t.prototype.track = function (t) {
              var n = this,
                e = t.targetTouches;
              return (
                Array.from(e).forEach(function (t) {
                  n._add(t);
                }),
                this._touchList
              );
            }),
            (t.prototype.update = function (t) {
              var n = this,
                e = t.touches,
                r = t.changedTouches;
              return (
                Array.from(e).forEach(function (t) {
                  n._renew(t);
                }),
                this._setActiveID(r),
                this._touchList
              );
            }),
            (t.prototype.release = function (t) {
              var n = this;
              delete this._activeTouchID,
                Array.from(t.changedTouches).forEach(function (t) {
                  n._delete(t);
                });
            }),
            (t.prototype._add = function (t) {
              if (!this._has(t)) {
                var n = new X(t);
                this._touchList[t.identifier] = n;
              }
            }),
            (t.prototype._renew = function (t) {
              this._has(t) && this._touchList[t.identifier].update(t);
            }),
            (t.prototype._delete = function (t) {
              delete this._touchList[t.identifier];
            }),
            (t.prototype._has = function (t) {
              return this._touchList.hasOwnProperty(t.identifier);
            }),
            (t.prototype._setActiveID = function (t) {
              this._activeTouchID = t[t.length - 1].identifier;
            }),
            (t.prototype._getActiveTracker = function () {
              return this._touchList[this._activeTouchID];
            }),
            t
          );
        })();
      !(function (t) {
        (t.X = "x"), (t.Y = "y");
      })(G || (G = {}));
      var U = (function () {
          function t(t, n) {
            void 0 === n && (n = 0),
              (this._direction = t),
              (this._minSize = n),
              (this.element = document.createElement("div")),
              (this.displaySize = 0),
              (this.realSize = 0),
              (this.offset = 0),
              (this.element.className = "scrollbar-thumb scrollbar-thumb-" + t);
          }
          return (
            (t.prototype.attachTo = function (t) {
              t.appendChild(this.element);
            }),
            (t.prototype.update = function (t, n, e) {
              (this.realSize = Math.min(n / e, 1) * n),
                (this.displaySize = Math.max(this.realSize, this._minSize)),
                (this.offset =
                  (t / e) * (n + (this.realSize - this.displaySize))),
                B(this.element, this._getStyle());
            }),
            (t.prototype._getStyle = function () {
              switch (this._direction) {
                case G.X:
                  return {
                    width: this.displaySize + "px",
                    "-transform": "translate3d(" + this.offset + "px, 0, 0)",
                  };
                case G.Y:
                  return {
                    height: this.displaySize + "px",
                    "-transform": "translate3d(0, " + this.offset + "px, 0)",
                  };
                default:
                  return null;
              }
            }),
            t
          );
        })(),
        Y = (function () {
          function t(t, n) {
            void 0 === n && (n = 0),
              (this.element = document.createElement("div")),
              (this._isShown = !1),
              (this.element.className = "scrollbar-track scrollbar-track-" + t),
              (this.thumb = new U(t, n)),
              this.thumb.attachTo(this.element);
          }
          return (
            (t.prototype.attachTo = function (t) {
              t.appendChild(this.element);
            }),
            (t.prototype.show = function () {
              this._isShown ||
                ((this._isShown = !0), this.element.classList.add("show"));
            }),
            (t.prototype.hide = function () {
              this._isShown &&
                ((this._isShown = !1), this.element.classList.remove("show"));
            }),
            (t.prototype.update = function (t, n, e) {
              B(this.element, { display: e <= n ? "none" : "block" }),
                this.thumb.update(t, n, e);
            }),
            t
          );
        })(),
        q = (function () {
          function t(t) {
            this._scrollbar = t;
            var n = t.options.thumbMinSize;
            (this.xAxis = new Y(G.X, n)),
              (this.yAxis = new Y(G.Y, n)),
              this.xAxis.attachTo(t.containerEl),
              this.yAxis.attachTo(t.containerEl),
              t.options.alwaysShowTracks &&
                (this.xAxis.show(), this.yAxis.show());
          }
          return (
            (t.prototype.update = function () {
              var t = this._scrollbar,
                n = t.size,
                e = t.offset;
              this.xAxis.update(e.x, n.container.width, n.content.width),
                this.yAxis.update(e.y, n.container.height, n.content.height);
            }),
            (t.prototype.autoHideOnIdle = function () {
              this._scrollbar.options.alwaysShowTracks ||
                (this.xAxis.hide(), this.yAxis.hide());
            }),
            u([D(300)], t.prototype, "autoHideOnIdle", null),
            t
          );
        })(),
        K = new WeakMap();
      function $(t) {
        return Math.pow(t - 1, 3) + 1;
      }
      var J,
        Q,
        Z,
        tt = (function () {
          function t(t, n) {
            var e = this.constructor;
            (this.scrollbar = t),
              (this.name = e.pluginName),
              (this.options = i(i({}, e.defaultOptions), n));
          }
          return (
            (t.prototype.onInit = function () {}),
            (t.prototype.onDestory = function () {}),
            (t.prototype.onUpdate = function () {}),
            (t.prototype.onRender = function (t) {}),
            (t.prototype.transformDelta = function (t, n) {
              return i({}, t);
            }),
            (t.pluginName = ""),
            (t.defaultOptions = {}),
            t
          );
        })(),
        nt = { order: new Set(), constructors: {} };
      function et(t) {
        var n = R(t),
          e = t.containerEl;
        n(e, "keydown", function (n) {
          var r = document.activeElement;
          if (
            (r === e || e.contains(r)) &&
            !(function (t) {
              return (
                !(
                  "INPUT" !== t.tagName &&
                  "TEXTAREA" !== t.tagName &&
                  !t.isContentEditable
                ) && !t.disabled
              );
            })(r)
          ) {
            var o = (function (t, n) {
              var e = t.size,
                r = t.limit,
                o = t.offset;
              switch (n) {
                case J.TAB:
                  return (function (t) {
                    requestAnimationFrame(function () {
                      t.scrollIntoView(document.activeElement, {
                        offsetTop: t.size.container.height / 2,
                        onlyScrollIfNeeded: !0,
                      });
                    });
                  })(t);
                case J.SPACE:
                  return [0, 200];
                case J.PAGE_UP:
                  return [0, 40 - e.container.height];
                case J.PAGE_DOWN:
                  return [0, e.container.height - 40];
                case J.END:
                  return [0, r.y - o.y];
                case J.HOME:
                  return [0, -o.y];
                case J.LEFT:
                  return [-40, 0];
                case J.UP:
                  return [0, -40];
                case J.RIGHT:
                  return [40, 0];
                case J.DOWN:
                  return [0, 40];
                default:
                  return null;
              }
            })(t, n.keyCode || n.which);
            if (o) {
              var i = o[0],
                u = o[1];
              t.addTransformableMomentum(i, u, n, function (e) {
                e
                  ? n.preventDefault()
                  : (t.containerEl.blur(),
                    t.parent && t.parent.containerEl.focus());
              });
            }
          }
        });
      }
      function rt(t) {
        var n,
          e,
          r,
          o,
          i,
          u = R(t),
          c = t.containerEl,
          s = t.track,
          a = s.xAxis,
          f = s.yAxis;
        function l(n, e) {
          var r = t.size;
          return n === Q.X
            ? (e /
                (r.container.width +
                  (a.thumb.realSize - a.thumb.displaySize))) *
                r.content.width
            : n === Q.Y
            ? (e /
                (r.container.height +
                  (f.thumb.realSize - f.thumb.displaySize))) *
              r.content.height
            : 0;
        }
        function p(t) {
          return I(t, [a.element, a.thumb.element])
            ? Q.X
            : I(t, [f.element, f.thumb.element])
            ? Q.Y
            : void 0;
        }
        u(c, "click", function (n) {
          if (!e && I(n.target, [a.element, f.element])) {
            var r = n.target,
              o = p(r),
              i = r.getBoundingClientRect(),
              u = F(n),
              c = t.offset,
              s = t.limit;
            if (o === Q.X) {
              var h = u.x - i.left - a.thumb.displaySize / 2;
              t.setMomentum(O(l(o, h) - c.x, -c.x, s.x - c.x), 0);
            }
            o === Q.Y &&
              ((h = u.y - i.top - f.thumb.displaySize / 2),
              t.setMomentum(0, O(l(o, h) - c.y, -c.y, s.y - c.y)));
          }
        }),
          u(c, "mousedown", function (e) {
            if (I(e.target, [a.thumb.element, f.thumb.element])) {
              n = !0;
              var u = e.target,
                s = F(e),
                l = u.getBoundingClientRect();
              (o = p(u)),
                (r = { x: s.x - l.left, y: s.y - l.top }),
                (i = c.getBoundingClientRect()),
                B(t.containerEl, { "-user-select": "none" });
            }
          }),
          u(window, "mousemove", function (u) {
            if (n) {
              e = !0;
              var c = t.offset,
                s = F(u);
              if (o === Q.X) {
                var a = s.x - r.x - i.left;
                t.setPosition(l(o, a), c.y);
              }
              o === Q.Y &&
                ((a = s.y - r.y - i.top), t.setPosition(c.x, l(o, a)));
            }
          }),
          u(window, "mouseup blur", function () {
            (n = e = !1), B(t.containerEl, { "-user-select": "" });
          });
      }
      function ot(t) {
        R(t)(window, "resize", k(t.update.bind(t), 300));
      }
      function it(t) {
        var n,
          e = R(t),
          r = t.containerEl,
          o = t.contentEl,
          i = t.offset,
          u = t.limit,
          c = !1;
        e(window, "mousemove", function (e) {
          c &&
            (cancelAnimationFrame(n),
            (function e(r) {
              var o = r.x,
                c = r.y;
              (o || c) &&
                (t.setMomentum(
                  O(i.x + o, 0, u.x) - i.x,
                  O(i.y + c, 0, u.y) - i.y
                ),
                (n = requestAnimationFrame(function () {
                  e({ x: o, y: c });
                })));
            })(
              (function (t, n) {
                var e = t.bounding,
                  r = e.top,
                  o = e.right,
                  i = e.bottom,
                  u = e.left,
                  c = F(n),
                  s = c.x,
                  a = c.y,
                  f = { x: 0, y: 0 };
                return 0 === s && 0 === a
                  ? f
                  : (s > o - 20
                      ? (f.x = s - o + 20)
                      : s < u + 20 && (f.x = s - u - 20),
                    a > i - 20
                      ? (f.y = a - i + 20)
                      : a < r + 20 && (f.y = a - r - 20),
                    (f.x *= 2),
                    (f.y *= 2),
                    f);
              })(t, e)
            ));
        }),
          e(o, "selectstart", function (t) {
            t.stopPropagation(), cancelAnimationFrame(n), (c = !0);
          }),
          e(window, "mouseup blur", function () {
            cancelAnimationFrame(n), (c = !1);
          }),
          e(r, "scroll", function (t) {
            t.preventDefault(), (r.scrollTop = r.scrollLeft = 0);
          });
      }
      function ut(t) {
        var n,
          e = /Android/.test(navigator.userAgent) ? 3 : 2,
          r = t.options.delegateTo || t.containerEl,
          o = new V(),
          i = R(t),
          u = 0;
        i(r, "touchstart", function (e) {
          o.track(e),
            t.setMomentum(0, 0),
            0 === u &&
              ((n = t.options.damping), (t.options.damping = Math.max(n, 0.5))),
            u++;
        }),
          i(r, "touchmove", function (n) {
            if (!Z || Z === t) {
              o.update(n);
              var e = o.getDelta(),
                r = e.x,
                i = e.y;
              t.addTransformableMomentum(r, i, n, function (e) {
                e && (n.preventDefault(), (Z = t));
              });
            }
          }),
          i(r, "touchcancel touchend", function (r) {
            var i = o.getVelocity(),
              c = { x: 0, y: 0 };
            Object.keys(i).forEach(function (t) {
              var r = i[t] / n;
              c[t] = Math.abs(r) < 50 ? 0 : r * e;
            }),
              t.addTransformableMomentum(c.x, c.y, r),
              0 == --u && (t.options.damping = n),
              o.release(r),
              (Z = null);
          });
      }
      function ct(t) {
        R(t)(
          t.options.delegateTo || t.containerEl,
          "onwheel" in window ||
            document.implementation.hasFeature("Events.wheel", "3.0")
            ? "wheel"
            : "mousewheel",
          function (n) {
            var e = (function (t) {
                if ("deltaX" in t) {
                  var n = ft(t.deltaMode);
                  return {
                    x: (t.deltaX / st.STANDARD) * n,
                    y: (t.deltaY / st.STANDARD) * n,
                  };
                }
                return "wheelDeltaX" in t
                  ? {
                      x: t.wheelDeltaX / st.OTHERS,
                      y: t.wheelDeltaY / st.OTHERS,
                    }
                  : { x: 0, y: t.wheelDelta / st.OTHERS };
              })(n),
              r = e.x,
              o = e.y;
            t.addTransformableMomentum(r, o, n, function (t) {
              t && n.preventDefault();
            });
          }
        );
      }
      !(function (t) {
        (t[(t.TAB = 9)] = "TAB"),
          (t[(t.SPACE = 32)] = "SPACE"),
          (t[(t.PAGE_UP = 33)] = "PAGE_UP"),
          (t[(t.PAGE_DOWN = 34)] = "PAGE_DOWN"),
          (t[(t.END = 35)] = "END"),
          (t[(t.HOME = 36)] = "HOME"),
          (t[(t.LEFT = 37)] = "LEFT"),
          (t[(t.UP = 38)] = "UP"),
          (t[(t.RIGHT = 39)] = "RIGHT"),
          (t[(t.DOWN = 40)] = "DOWN");
      })(J || (J = {})),
        (function (t) {
          (t[(t.X = 0)] = "X"), (t[(t.Y = 1)] = "Y");
        })(Q || (Q = {}));
      var st = { STANDARD: 1, OTHERS: -3 },
        at = [1, 28, 500],
        ft = function (t) {
          return at[t] || at[0];
        },
        lt = new Map(),
        pt = (function () {
          function t(t, n) {
            var e = this;
            (this.offset = { x: 0, y: 0 }),
              (this.limit = { x: 1 / 0, y: 1 / 0 }),
              (this.bounding = { top: 0, right: 0, bottom: 0, left: 0 }),
              (this._plugins = []),
              (this._momentum = { x: 0, y: 0 }),
              (this._listeners = new Set()),
              (this.containerEl = t);
            var r = (this.contentEl = document.createElement("div"));
            (this.options = new N(n)),
              t.setAttribute("data-scrollbar", "true"),
              t.setAttribute("tabindex", "-1"),
              B(t, { overflow: "hidden", outline: "none" }),
              window.navigator.msPointerEnabled &&
                (t.style.msTouchAction = "none"),
              (r.className = "scroll-content"),
              Array.from(t.childNodes).forEach(function (t) {
                r.appendChild(t);
              }),
              t.appendChild(r),
              (this.track = new q(this)),
              (this.size = this.getSize()),
              (this._plugins = (function (t, n) {
                return Array.from(nt.order)
                  .filter(function (t) {
                    return !1 !== n[t];
                  })
                  .map(function (e) {
                    var r = new (0, nt.constructors[e])(t, n[e]);
                    return (n[e] = r.options), r;
                  });
              })(this, this.options.plugins));
            var o = t.scrollLeft,
              i = t.scrollTop;
            (t.scrollLeft = t.scrollTop = 0),
              this.setPosition(o, i, { withoutCallbacks: !0 });
            var u = window,
              c =
                u.MutationObserver ||
                u.WebKitMutationObserver ||
                u.MozMutationObserver;
            "function" == typeof c &&
              ((this._observer = new c(function () {
                e.update();
              })),
              this._observer.observe(r, { subtree: !0, childList: !0 })),
              lt.set(t, this),
              requestAnimationFrame(function () {
                e._init();
              });
          }
          return (
            Object.defineProperty(t.prototype, "parent", {
              get: function () {
                for (var t = this.containerEl.parentElement; t; ) {
                  var n = lt.get(t);
                  if (n) return n;
                  t = t.parentElement;
                }
                return null;
              },
              enumerable: !0,
              configurable: !0,
            }),
            Object.defineProperty(t.prototype, "scrollTop", {
              get: function () {
                return this.offset.y;
              },
              set: function (t) {
                this.setPosition(this.scrollLeft, t);
              },
              enumerable: !0,
              configurable: !0,
            }),
            Object.defineProperty(t.prototype, "scrollLeft", {
              get: function () {
                return this.offset.x;
              },
              set: function (t) {
                this.setPosition(t, this.scrollTop);
              },
              enumerable: !0,
              configurable: !0,
            }),
            (t.prototype.getSize = function () {
              return (function (t) {
                var n = t.containerEl,
                  e = t.contentEl;
                return {
                  container: { width: n.clientWidth, height: n.clientHeight },
                  content: {
                    width: e.offsetWidth - e.clientWidth + e.scrollWidth,
                    height: e.offsetHeight - e.clientHeight + e.scrollHeight,
                  },
                };
              })(this);
            }),
            (t.prototype.update = function () {
              !(function (t) {
                var n = t.getSize(),
                  e = {
                    x: Math.max(n.content.width - n.container.width, 0),
                    y: Math.max(n.content.height - n.container.height, 0),
                  },
                  r = t.containerEl.getBoundingClientRect(),
                  o = {
                    top: Math.max(r.top, 0),
                    right: Math.min(r.right, window.innerWidth),
                    bottom: Math.min(r.bottom, window.innerHeight),
                    left: Math.max(r.left, 0),
                  };
                (t.size = n),
                  (t.limit = e),
                  (t.bounding = o),
                  t.track.update(),
                  t.setPosition();
              })(this),
                this._plugins.forEach(function (t) {
                  t.onUpdate();
                });
            }),
            (t.prototype.isVisible = function (t) {
              return (function (t, n) {
                var e = t.bounding,
                  r = n.getBoundingClientRect(),
                  o = Math.max(e.top, r.top),
                  i = Math.max(e.left, r.left),
                  u = Math.min(e.right, r.right);
                return o < Math.min(e.bottom, r.bottom) && i < u;
              })(this, t);
            }),
            (t.prototype.setPosition = function (t, n, e) {
              var r = this;
              void 0 === t && (t = this.offset.x),
                void 0 === n && (n = this.offset.y),
                void 0 === e && (e = {});
              var o = (function (t, n, e) {
                var r = t.options,
                  o = t.offset,
                  u = t.limit,
                  c = t.track,
                  s = t.contentEl;
                return (
                  r.renderByPixels &&
                    ((n = Math.round(n)), (e = Math.round(e))),
                  (n = O(n, 0, u.x)),
                  (e = O(e, 0, u.y)),
                  n !== o.x && c.xAxis.show(),
                  e !== o.y && c.yAxis.show(),
                  r.alwaysShowTracks || c.autoHideOnIdle(),
                  n === o.x && e === o.y
                    ? null
                    : ((o.x = n),
                      (o.y = e),
                      B(s, {
                        "-transform":
                          "translate3d(" + -n + "px, " + -e + "px, 0)",
                      }),
                      c.update(),
                      { offset: i({}, o), limit: i({}, u) })
                );
              })(this, t, n);
              o &&
                !e.withoutCallbacks &&
                this._listeners.forEach(function (t) {
                  t.call(r, o);
                });
            }),
            (t.prototype.scrollTo = function (t, n, e, r) {
              void 0 === t && (t = this.offset.x),
                void 0 === n && (n = this.offset.y),
                void 0 === e && (e = 0),
                void 0 === r && (r = {}),
                (function (t, n, e, r, o) {
                  void 0 === r && (r = 0);
                  var i = void 0 === o ? {} : o,
                    u = i.easing,
                    c = void 0 === u ? $ : u,
                    s = i.callback,
                    a = t.options,
                    f = t.offset,
                    l = t.limit;
                  a.renderByPixels &&
                    ((n = Math.round(n)), (e = Math.round(e)));
                  var p = f.x,
                    h = f.y,
                    d = O(n, 0, l.x) - p,
                    v = O(e, 0, l.y) - h,
                    y = Date.now();
                  cancelAnimationFrame(K.get(t)),
                    (function n() {
                      var e = Date.now() - y,
                        o = r ? c(Math.min(e / r, 1)) : 1;
                      if ((t.setPosition(p + d * o, h + v * o), e >= r))
                        "function" == typeof s && s.call(t);
                      else {
                        var i = requestAnimationFrame(n);
                        K.set(t, i);
                      }
                    })();
                })(this, t, n, e, r);
            }),
            (t.prototype.scrollIntoView = function (t, n) {
              void 0 === n && (n = {}),
                (function (t, n, e) {
                  var r = void 0 === e ? {} : e,
                    o = r.alignToTop,
                    i = void 0 === o || o,
                    u = r.onlyScrollIfNeeded,
                    c = void 0 !== u && u,
                    s = r.offsetTop,
                    a = void 0 === s ? 0 : s,
                    f = r.offsetLeft,
                    l = void 0 === f ? 0 : f,
                    p = r.offsetBottom,
                    h = void 0 === p ? 0 : p,
                    d = t.containerEl,
                    v = t.bounding,
                    y = t.offset,
                    m = t.limit;
                  if (n && d.contains(n)) {
                    var g = n.getBoundingClientRect();
                    if (!c || !t.isVisible(n)) {
                      var b = i ? g.top - v.top - a : g.bottom - v.bottom + h;
                      t.setMomentum(g.left - v.left - l, O(b, -y.y, m.y - y.y));
                    }
                  }
                })(this, t, n);
            }),
            (t.prototype.addListener = function (t) {
              if ("function" != typeof t)
                throw new TypeError(
                  "[smooth-scrollbar] scrolling listener should be a function"
                );
              this._listeners.add(t);
            }),
            (t.prototype.removeListener = function (t) {
              this._listeners.delete(t);
            }),
            (t.prototype.addTransformableMomentum = function (t, n, e, r) {
              this._updateDebounced();
              var o = this._plugins.reduce(
                  function (t, n) {
                    return n.transformDelta(t, e) || t;
                  },
                  { x: t, y: n }
                ),
                i = !this._shouldPropagateMomentum(o.x, o.y);
              i && this.addMomentum(o.x, o.y), r && r.call(this, i);
            }),
            (t.prototype.addMomentum = function (t, n) {
              this.setMomentum(this._momentum.x + t, this._momentum.y + n);
            }),
            (t.prototype.setMomentum = function (t, n) {
              0 === this.limit.x && (t = 0),
                0 === this.limit.y && (n = 0),
                this.options.renderByPixels &&
                  ((t = Math.round(t)), (n = Math.round(n))),
                (this._momentum.x = t),
                (this._momentum.y = n);
            }),
            (t.prototype.updatePluginOptions = function (t, n) {
              this._plugins.forEach(function (e) {
                e.name === t && Object.assign(e.options, n);
              });
            }),
            (t.prototype.destroy = function () {
              var t = this.containerEl,
                n = this.contentEl;
              !(function (t) {
                var n = z.get(t);
                n &&
                  (n.forEach(function (t) {
                    var n = t.elem,
                      e = t.eventName,
                      r = t.handler;
                    n.removeEventListener(e, r, C());
                  }),
                  z.delete(t));
              })(this),
                this._listeners.clear(),
                this.setMomentum(0, 0),
                cancelAnimationFrame(this._renderID),
                this._observer && this._observer.disconnect(),
                lt.delete(this.containerEl);
              for (var e = Array.from(n.childNodes); t.firstChild; )
                t.removeChild(t.firstChild);
              e.forEach(function (n) {
                t.appendChild(n);
              }),
                B(t, { overflow: "" }),
                (t.scrollTop = this.scrollTop),
                (t.scrollLeft = this.scrollLeft),
                this._plugins.forEach(function (t) {
                  t.onDestory();
                }),
                (this._plugins.length = 0);
            }),
            (t.prototype._init = function () {
              var t = this;
              this.update(),
                Object.keys(r).forEach(function (n) {
                  r[n](t);
                }),
                this._plugins.forEach(function (t) {
                  t.onInit();
                }),
                this._render();
            }),
            (t.prototype._updateDebounced = function () {
              this.update();
            }),
            (t.prototype._shouldPropagateMomentum = function (t, n) {
              void 0 === t && (t = 0), void 0 === n && (n = 0);
              var e = this.options,
                r = this.offset,
                o = this.limit;
              if (!e.continuousScrolling) return !1;
              0 === o.x && 0 === o.y && this._updateDebounced();
              var i = O(t + r.x, 0, o.x),
                u = O(n + r.y, 0, o.y),
                c = !0;
              return (
                (c = (c = c && i === r.x) && u === r.y) &&
                (r.x === o.x || 0 === r.x || r.y === o.y || 0 === r.y)
              );
            }),
            (t.prototype._render = function () {
              var t = this._momentum;
              if (t.x || t.y) {
                var n = this._nextTick("x"),
                  e = this._nextTick("y");
                (t.x = n.momentum),
                  (t.y = e.momentum),
                  this.setPosition(n.position, e.position);
              }
              var r = i({}, this._momentum);
              this._plugins.forEach(function (t) {
                t.onRender(r);
              }),
                (this._renderID = requestAnimationFrame(
                  this._render.bind(this)
                ));
            }),
            (t.prototype._nextTick = function (t) {
              var n = this.options,
                e = this.offset,
                r = this._momentum,
                o = e[t],
                i = r[t];
              if (Math.abs(i) <= 0.1) return { momentum: 0, position: o + i };
              var u = i * (1 - n.damping);
              return (
                n.renderByPixels && (u |= 0),
                { momentum: u, position: o + i - u }
              );
            }),
            u([D(100, { leading: !0 })], t.prototype, "_updateDebounced", null),
            t
          );
        })(),
        ht =
          "\n[data-scrollbar] {\n  display: block;\n  position: relative;\n}\n\n.scroll-content {\n  -webkit-transform: translate3d(0, 0, 0);\n          transform: translate3d(0, 0, 0);\n}\n\n.scrollbar-track {\n  position: absolute;\n  opacity: 0;\n  z-index: 1;\n  background: rgba(222, 222, 222, .75);\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-transition: opacity 0.5s 0.5s ease-out;\n          transition: opacity 0.5s 0.5s ease-out;\n}\n.scrollbar-track.show,\n.scrollbar-track:hover {\n  opacity: 1;\n  -webkit-transition-delay: 0s;\n          transition-delay: 0s;\n}\n\n.scrollbar-track-x {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  height: 8px;\n}\n.scrollbar-track-y {\n  top: 0;\n  right: 0;\n  width: 8px;\n  height: 100%;\n}\n.scrollbar-thumb {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 8px;\n  height: 8px;\n  background: rgba(0, 0, 0, .5);\n  border-radius: 4px;\n}\n",
        dt = "smooth-scrollbar-style",
        vt = !1;
      function yt() {
        if (!vt && "undefined" != typeof window) {
          var t = document.createElement("style");
          (t.id = dt),
            (t.textContent = ht),
            document.head && document.head.appendChild(t),
            (vt = !0);
        }
      }
      e.d(n, "ScrollbarPlugin", function () {
        return tt;
      });
      /*!
       * cast `I.Scrollbar` to `Scrollbar` to avoid error
       *
       * `I.Scrollbar` is not assignable to `Scrollbar`:
       *     "privateProp" is missing in `I.Scrollbar`
       *
       * @see https://github.com/Microsoft/TypeScript/issues/2672
       */
      var mt = (function (t) {
        function n() {
          return (null !== t && t.apply(this, arguments)) || this;
        }
        return (
          (function (t, n) {
            function e() {
              this.constructor = t;
            }
            o(t, n),
              (t.prototype =
                null === n
                  ? Object.create(n)
                  : ((e.prototype = n.prototype), new e()));
          })(n, t),
          (n.init = function (t, n) {
            if (!t || 1 !== t.nodeType)
              throw new TypeError(
                "expect element to be DOM Element, but got " + t
              );
            return yt(), lt.has(t) ? lt.get(t) : new pt(t, n);
          }),
          (n.initAll = function (t) {
            return Array.from(
              document.querySelectorAll("[data-scrollbar]"),
              function (e) {
                return n.init(e, t);
              }
            );
          }),
          (n.has = function (t) {
            return lt.has(t);
          }),
          (n.get = function (t) {
            return lt.get(t);
          }),
          (n.getAll = function () {
            return Array.from(lt.values());
          }),
          (n.destroy = function (t) {
            var n = lt.get(t);
            n && n.destroy();
          }),
          (n.destroyAll = function () {
            lt.forEach(function (t) {
              t.destroy();
            });
          }),
          (n.use = function () {
            for (var t = [], n = 0; n < arguments.length; n++)
              t[n] = arguments[n];
            return function () {
              for (var t = [], n = 0; n < arguments.length; n++)
                t[n] = arguments[n];
              t.forEach(function (t) {
                var n = t.pluginName;
                if (!n) throw new TypeError("plugin name is required");
                nt.order.add(n), (nt.constructors[n] = t);
              });
            }.apply(void 0, t);
          }),
          (n.attachStyle = function () {
            return yt();
          }),
          (n.detachStyle = function () {
            return (function () {
              if (vt && "undefined" != typeof window) {
                var t = document.getElementById(dt);
                t && t.parentNode && (t.parentNode.removeChild(t), (vt = !1));
              }
            })();
          }),
          (n.version = "8.4.1"),
          (n.ScrollbarPlugin = tt),
          n
        );
      })(pt);
      n.default = mt;
    },
  ]).default;
});

//https://github.com/idiotWu/smooth-scrollbar
//vimeo player.js
/*! @vimeo/player v2.10.0 | (c) 2019 Vimeo | MIT License | https://github.com/vimeo/player.js */
!(function (e, t) {
  "object" == typeof exports && "undefined" != typeof module
    ? (module.exports = t())
    : "function" == typeof define && define.amd
    ? define(t)
    : (((e = e || self).Vimeo = e.Vimeo || {}), (e.Vimeo.Player = t()));
})(this, function () {
  "use strict";
  function r(e, t) {
    for (var n = 0; n < t.length; n++) {
      var r = t[n];
      (r.enumerable = r.enumerable || !1),
        (r.configurable = !0),
        "value" in r && (r.writable = !0),
        Object.defineProperty(e, r.key, r);
    }
  }
  var e =
    "undefined" != typeof global &&
    "[object global]" === {}.toString.call(global);
  function i(e, t) {
    return 0 === e.indexOf(t.toLowerCase())
      ? e
      : ""
          .concat(t.toLowerCase())
          .concat(e.substr(0, 1).toUpperCase())
          .concat(e.substr(1));
  }
  function s(e) {
    return /^(https?:)?\/\/((player|www)\.)?vimeo\.com(?=$|\/)/.test(e);
  }
  function l() {
    var e,
      t = 0 < arguments.length && void 0 !== arguments[0] ? arguments[0] : {},
      n = t.id,
      r = t.url,
      o = n || r;
    if (!o)
      throw new Error(
        "An id or url must be passed, either in an options object or as a data-vimeo-id or data-vimeo-url attribute."
      );
    if (((e = o), !isNaN(parseFloat(e)) && isFinite(e) && Math.floor(e) == e))
      return "https://vimeo.com/".concat(o);
    if (s(o)) return o.replace("http:", "https:");
    if (n) throw new TypeError("â€œ".concat(n, "â€ is not a valid video id."));
    throw new TypeError("â€œ".concat(o, "â€ is not a vimeo.com url."));
  }
  var t = void 0 !== Array.prototype.indexOf,
    n = "undefined" != typeof window && void 0 !== window.postMessage;
  if (!(e || (t && n)))
    throw new Error(
      "Sorry, the Vimeo Player API is not available in this browser."
    );
  var o =
    "undefined" != typeof window
      ? window
      : "undefined" != typeof global
      ? global
      : "undefined" != typeof self
      ? self
      : {};
  !(function (e) {
    if (!e.WeakMap) {
      var n = Object.prototype.hasOwnProperty,
        o = function (e, t, n) {
          Object.defineProperty
            ? Object.defineProperty(e, t, {
                configurable: !0,
                writable: !0,
                value: n,
              })
            : (e[t] = n);
        };
      e.WeakMap = (function () {
        function e() {
          if (void 0 === this)
            throw new TypeError("Constructor WeakMap requires 'new'");
          if (
            (o(this, "_id", "_WeakMap" + "_" + t() + "." + t()),
            0 < arguments.length)
          )
            throw new TypeError("WeakMap iterable is not supported");
        }
        function r(e, t) {
          if (!i(e) || !n.call(e, "_id"))
            throw new TypeError(
              t + " method called on incompatible receiver " + typeof e
            );
        }
        function t() {
          return Math.random().toString().substring(2);
        }
        return (
          o(e.prototype, "delete", function (e) {
            if ((r(this, "delete"), !i(e))) return !1;
            var t = e[this._id];
            return !(!t || t[0] !== e) && (delete e[this._id], !0);
          }),
          o(e.prototype, "get", function (e) {
            if ((r(this, "get"), i(e))) {
              var t = e[this._id];
              return t && t[0] === e ? t[1] : void 0;
            }
          }),
          o(e.prototype, "has", function (e) {
            if ((r(this, "has"), !i(e))) return !1;
            var t = e[this._id];
            return !(!t || t[0] !== e);
          }),
          o(e.prototype, "set", function (e, t) {
            if ((r(this, "set"), !i(e)))
              throw new TypeError("Invalid value used as weak map key");
            var n = e[this._id];
            return n && n[0] === e ? (n[1] = t) : o(e, this._id, [e, t]), this;
          }),
          o(e, "_polyfill", !0),
          e
        );
      })();
    }
    function i(e) {
      return Object(e) === e;
    }
  })(
    "undefined" != typeof self
      ? self
      : "undefined" != typeof window
      ? window
      : o
  );
  var a,
    f =
      ((function (e) {
        var t, n, r;
        (r = function () {
          var t,
            a,
            n,
            e = Object.prototype.toString,
            r =
              "undefined" != typeof setImmediate
                ? function (e) {
                    return setImmediate(e);
                  }
                : setTimeout;
          try {
            Object.defineProperty({}, "x", {}),
              (t = function (e, t, n, r) {
                return Object.defineProperty(e, t, {
                  value: n,
                  writable: !0,
                  configurable: !1 !== r,
                });
              });
          } catch (e) {
            t = function (e, t, n) {
              return (e[t] = n), e;
            };
          }
          function i(e, t) {
            n.add(e, t), a || (a = r(n.drain));
          }
          function u(e) {
            var t,
              n = typeof e;
            return (
              null == e || ("object" != n && "function" != n) || (t = e.then),
              "function" == typeof t && t
            );
          }
          function c() {
            for (var e = 0; e < this.chain.length; e++)
              o(
                this,
                1 === this.state
                  ? this.chain[e].success
                  : this.chain[e].failure,
                this.chain[e]
              );
            this.chain.length = 0;
          }
          function o(e, t, n) {
            var r, o;
            try {
              !1 === t
                ? n.reject(e.msg)
                : (r = !0 === t ? e.msg : t.call(void 0, e.msg)) === n.promise
                ? n.reject(TypeError("Promise-chain cycle"))
                : (o = u(r))
                ? o.call(r, n.resolve, n.reject)
                : n.resolve(r);
            } catch (e) {
              n.reject(e);
            }
          }
          function s(e) {
            var t = this;
            t.triggered ||
              ((t.triggered = !0),
              t.def && (t = t.def),
              (t.msg = e),
              (t.state = 2),
              0 < t.chain.length && i(c, t));
          }
          function l(e, n, r, o) {
            for (var t = 0; t < n.length; t++)
              !(function (t) {
                e.resolve(n[t]).then(function (e) {
                  r(t, e);
                }, o);
              })(t);
          }
          function f(e) {
            (this.def = e), (this.triggered = !1);
          }
          function d(e) {
            (this.promise = e),
              (this.state = 0),
              (this.triggered = !1),
              (this.chain = []),
              (this.msg = void 0);
          }
          function h(e) {
            if ("function" != typeof e) throw TypeError("Not a function");
            if (0 !== this.__NPO__) throw TypeError("Not a promise");
            this.__NPO__ = 1;
            var r = new d(this);
            (this.then = function (e, t) {
              var n = {
                success: "function" != typeof e || e,
                failure: "function" == typeof t && t,
              };
              return (
                (n.promise = new this.constructor(function (e, t) {
                  if ("function" != typeof e || "function" != typeof t)
                    throw TypeError("Not a function");
                  (n.resolve = e), (n.reject = t);
                })),
                r.chain.push(n),
                0 !== r.state && i(c, r),
                n.promise
              );
            }),
              (this.catch = function (e) {
                return this.then(void 0, e);
              });
            try {
              e.call(
                void 0,
                function (e) {
                  (function e(n) {
                    var r,
                      o = this;
                    if (!o.triggered) {
                      (o.triggered = !0), o.def && (o = o.def);
                      try {
                        (r = u(n))
                          ? i(function () {
                              var t = new f(o);
                              try {
                                r.call(
                                  n,
                                  function () {
                                    e.apply(t, arguments);
                                  },
                                  function () {
                                    s.apply(t, arguments);
                                  }
                                );
                              } catch (e) {
                                s.call(t, e);
                              }
                            })
                          : ((o.msg = n),
                            (o.state = 1),
                            0 < o.chain.length && i(c, o));
                      } catch (e) {
                        s.call(new f(o), e);
                      }
                    }
                  }).call(r, e);
                },
                function (e) {
                  s.call(r, e);
                }
              );
            } catch (e) {
              s.call(r, e);
            }
          }
          n = (function () {
            var n, r, o;
            function i(e, t) {
              (this.fn = e), (this.self = t), (this.next = void 0);
            }
            return {
              add: function (e, t) {
                (o = new i(e, t)),
                  r ? (r.next = o) : (n = o),
                  (r = o),
                  (o = void 0);
              },
              drain: function () {
                var e = n;
                for (n = r = a = void 0; e; ) e.fn.call(e.self), (e = e.next);
              },
            };
          })();
          var v = t({}, "constructor", h, !1);
          return (
            t((h.prototype = v), "__NPO__", 0, !1),
            t(h, "resolve", function (n) {
              return n && "object" == typeof n && 1 === n.__NPO__
                ? n
                : new this(function (e, t) {
                    if ("function" != typeof e || "function" != typeof t)
                      throw TypeError("Not a function");
                    e(n);
                  });
            }),
            t(h, "reject", function (n) {
              return new this(function (e, t) {
                if ("function" != typeof e || "function" != typeof t)
                  throw TypeError("Not a function");
                t(n);
              });
            }),
            t(h, "all", function (t) {
              var a = this;
              return "[object Array]" != e.call(t)
                ? a.reject(TypeError("Not an array"))
                : 0 === t.length
                ? a.resolve([])
                : new a(function (n, e) {
                    if ("function" != typeof n || "function" != typeof e)
                      throw TypeError("Not a function");
                    var r = t.length,
                      o = Array(r),
                      i = 0;
                    l(
                      a,
                      t,
                      function (e, t) {
                        (o[e] = t), ++i === r && n(o);
                      },
                      e
                    );
                  });
            }),
            t(h, "race", function (t) {
              var r = this;
              return "[object Array]" != e.call(t)
                ? r.reject(TypeError("Not an array"))
                : new r(function (n, e) {
                    if ("function" != typeof n || "function" != typeof e)
                      throw TypeError("Not a function");
                    l(
                      r,
                      t,
                      function (e, t) {
                        n(t);
                      },
                      e
                    );
                  });
            }),
            h
          );
        }),
          ((n = o)[(t = "Promise")] = n[t] || r()),
          e.exports && (e.exports = n[t]);
      })((a = { exports: {} }), a.exports),
      a.exports),
    d = new WeakMap();
  function u(e, t, n) {
    var r = d.get(e.element) || {};
    t in r || (r[t] = []), r[t].push(n), d.set(e.element, r);
  }
  function c(e, t) {
    return (d.get(e.element) || {})[t] || [];
  }
  function h(e, t, n) {
    var r = d.get(e.element) || {};
    if (!r[t]) return !0;
    if (!n) return (r[t] = []), d.set(e.element, r), !0;
    var o = r[t].indexOf(n);
    return (
      -1 !== o && r[t].splice(o, 1),
      d.set(e.element, r),
      r[t] && 0 === r[t].length
    );
  }
  var v = [
    "autopause",
    "autoplay",
    "background",
    "byline",
    "color",
    "controls",
    "dnt",
    "height",
    "id",
    "loop",
    "maxheight",
    "maxwidth",
    "muted",
    "playsinline",
    "portrait",
    "responsive",
    "speed",
    "texttrack",
    "title",
    "transparent",
    "url",
    "width",
  ];
  function p(r) {
    var e = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
    return v.reduce(function (e, t) {
      var n = r.getAttribute("data-vimeo-".concat(t));
      return (n || "" === n) && (e[t] = "" === n ? 1 : n), e;
    }, e);
  }
  function y(e, t) {
    var n = e.html;
    if (!t) throw new TypeError("An element must be provided");
    if (null !== t.getAttribute("data-vimeo-initialized"))
      return t.querySelector("iframe");
    var r = document.createElement("div");
    return (
      (r.innerHTML = n),
      t.appendChild(r.firstChild),
      t.setAttribute("data-vimeo-initialized", "true"),
      t.querySelector("iframe")
    );
  }
  function m(i) {
    var a = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {},
      u = 2 < arguments.length ? arguments[2] : void 0;
    return new Promise(function (t, n) {
      if (!s(i))
        throw new TypeError("â€œ".concat(i, "â€ is not a vimeo.com url."));
      var e = "https://vimeo.com/api/oembed.json?url=".concat(
        encodeURIComponent(i)
      );
      for (var r in a)
        a.hasOwnProperty(r) &&
          (e += "&".concat(r, "=").concat(encodeURIComponent(a[r])));
      var o =
        "XDomainRequest" in window
          ? new XDomainRequest()
          : new XMLHttpRequest();
      o.open("GET", e, !0),
        (o.onload = function () {
          if (404 !== o.status)
            if (403 !== o.status)
              try {
                var e = JSON.parse(o.responseText);
                if (403 === e.domain_status_code)
                  return (
                    y(e, u),
                    void n(new Error("â€œ".concat(i, "â€ is not embeddable.")))
                  );
                t(e);
              } catch (e) {
                n(e);
              }
            else n(new Error("â€œ".concat(i, "â€ is not embeddable.")));
          else n(new Error("â€œ".concat(i, "â€ was not found.")));
        }),
        (o.onerror = function () {
          var e = o.status ? " (".concat(o.status, ")") : "";
          n(
            new Error(
              "There was an error fetching the embed code from Vimeo".concat(
                e,
                "."
              )
            )
          );
        }),
        o.send();
    });
  }
  function g(e) {
    if ("string" == typeof e)
      try {
        e = JSON.parse(e);
      } catch (e) {
        return console.warn(e), {};
      }
    return e;
  }
  function w(e, t, n) {
    if (e.element.contentWindow && e.element.contentWindow.postMessage) {
      var r = { method: t };
      void 0 !== n && (r.value = n);
      var o = parseFloat(
        navigator.userAgent.toLowerCase().replace(/^.*msie (\d+).*$/, "$1")
      );
      8 <= o && o < 10 && (r = JSON.stringify(r)),
        e.element.contentWindow.postMessage(r, e.origin);
    }
  }
  function b(n, r) {
    var t,
      e = [];
    if ((r = g(r)).event) {
      if ("error" === r.event)
        c(n, r.data.method).forEach(function (e) {
          var t = new Error(r.data.message);
          (t.name = r.data.name), e.reject(t), h(n, r.data.method, e);
        });
      (e = c(n, "event:".concat(r.event))), (t = r.data);
    } else if (r.method) {
      var o = (function (e, t) {
        var n = c(e, t);
        if (n.length < 1) return !1;
        var r = n.shift();
        return h(e, t, r), r;
      })(n, r.method);
      o && (e.push(o), (t = r.value));
    }
    e.forEach(function (e) {
      try {
        if ("function" == typeof e) return void e.call(n, t);
        e.resolve(t);
      } catch (e) {}
    });
  }
  var k = new WeakMap(),
    E = new WeakMap(),
    Player = (function () {
      function Player(u) {
        var e,
          c = this,
          n =
            1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : {};
        if (
          ((function (e, t) {
            if (!(e instanceof t))
              throw new TypeError("Cannot call a class as a function");
          })(this, Player),
          window.jQuery &&
            u instanceof jQuery &&
            (1 < u.length &&
              window.console &&
              console.warn &&
              console.warn(
                "A jQuery object with multiple elements was passed, using the first element."
              ),
            (u = u[0])),
          "undefined" != typeof document &&
            "string" == typeof u &&
            (u = document.getElementById(u)),
          (e = u),
          !Boolean(
            e &&
              1 === e.nodeType &&
              "nodeName" in e &&
              e.ownerDocument &&
              e.ownerDocument.defaultView
          ))
        )
          throw new TypeError(
            "You must pass either a valid element or a valid id."
          );
        var r = u.ownerDocument.defaultView;
        if ("IFRAME" !== u.nodeName) {
          var t = u.querySelector("iframe");
          t && (u = t);
        }
        if ("IFRAME" === u.nodeName && !s(u.getAttribute("src") || ""))
          throw new Error("The player element passed isnâ€™t a Vimeo embed.");
        if (k.has(u)) return k.get(u);
        (this.element = u), (this.origin = "*");
        var o = new f(function (i, a) {
          var e = function (e) {
            if (s(e.origin) && c.element.contentWindow === e.source) {
              "*" === c.origin && (c.origin = e.origin);
              var t = g(e.data);
              if (
                t &&
                "error" === t.event &&
                t.data &&
                "ready" === t.data.method
              ) {
                var n = new Error(t.data.message);
                return (n.name = t.data.name), void a(n);
              }
              var r = t && "ready" === t.event,
                o = t && "ping" === t.method;
              if (r || o)
                return c.element.setAttribute("data-ready", "true"), void i();
              b(c, t);
            }
          };
          if (
            (r.addEventListener
              ? r.addEventListener("message", e, !1)
              : r.attachEvent && r.attachEvent("onmessage", e),
            "IFRAME" !== c.element.nodeName)
          ) {
            var t = p(u, n);
            m(l(t), t, u)
              .then(function (e) {
                var t,
                  n,
                  r,
                  o = y(e, u);
                return (
                  (c.element = o),
                  (c._originalElement = u),
                  (t = u),
                  (n = o),
                  (r = d.get(t)),
                  d.set(n, r),
                  d.delete(t),
                  k.set(c.element, c),
                  e
                );
              })
              .catch(a);
          }
        });
        return (
          E.set(this, o),
          k.set(this.element, this),
          "IFRAME" === this.element.nodeName && w(this, "ping"),
          this
        );
      }
      var e, t, n;
      return (
        (e = Player),
        (t = [
          {
            key: "callMethod",
            value: function (n) {
              var r = this,
                o =
                  1 < arguments.length && void 0 !== arguments[1]
                    ? arguments[1]
                    : {};
              return new f(function (e, t) {
                return r
                  .ready()
                  .then(function () {
                    u(r, n, { resolve: e, reject: t }), w(r, n, o);
                  })
                  .catch(t);
              });
            },
          },
          {
            key: "get",
            value: function (n) {
              var r = this;
              return new f(function (e, t) {
                return (
                  (n = i(n, "get")),
                  r
                    .ready()
                    .then(function () {
                      u(r, n, { resolve: e, reject: t }), w(r, n);
                    })
                    .catch(t)
                );
              });
            },
          },
          {
            key: "set",
            value: function (n, r) {
              var o = this;
              return new f(function (e, t) {
                if (((n = i(n, "set")), null == r))
                  throw new TypeError("There must be a value to set.");
                return o
                  .ready()
                  .then(function () {
                    u(o, n, { resolve: e, reject: t }), w(o, n, r);
                  })
                  .catch(t);
              });
            },
          },
          {
            key: "on",
            value: function (e, t) {
              if (!e) throw new TypeError("You must pass an event name.");
              if (!t) throw new TypeError("You must pass a callback function.");
              if ("function" != typeof t)
                throw new TypeError("The callback must be a function.");
              0 === c(this, "event:".concat(e)).length &&
                this.callMethod("addEventListener", e).catch(function () {}),
                u(this, "event:".concat(e), t);
            },
          },
          {
            key: "off",
            value: function (e, t) {
              if (!e) throw new TypeError("You must pass an event name.");
              if (t && "function" != typeof t)
                throw new TypeError("The callback must be a function.");
              h(this, "event:".concat(e), t) &&
                this.callMethod("removeEventListener", e).catch(function (
                  e
                ) {});
            },
          },
          {
            key: "loadVideo",
            value: function (e) {
              return this.callMethod("loadVideo", e);
            },
          },
          {
            key: "ready",
            value: function () {
              var e =
                E.get(this) ||
                new f(function (e, t) {
                  t(new Error("Unknown player. Probably unloaded."));
                });
              return f.resolve(e);
            },
          },
          {
            key: "addCuePoint",
            value: function (e) {
              var t =
                1 < arguments.length && void 0 !== arguments[1]
                  ? arguments[1]
                  : {};
              return this.callMethod("addCuePoint", { time: e, data: t });
            },
          },
          {
            key: "removeCuePoint",
            value: function (e) {
              return this.callMethod("removeCuePoint", e);
            },
          },
          {
            key: "enableTextTrack",
            value: function (e, t) {
              if (!e) throw new TypeError("You must pass a language.");
              return this.callMethod("enableTextTrack", {
                language: e,
                kind: t,
              });
            },
          },
          {
            key: "disableTextTrack",
            value: function () {
              return this.callMethod("disableTextTrack");
            },
          },
          {
            key: "pause",
            value: function () {
              return this.callMethod("pause");
            },
          },
          {
            key: "play",
            value: function () {
              return this.callMethod("play");
            },
          },
          {
            key: "unload",
            value: function () {
              return this.callMethod("unload");
            },
          },
          {
            key: "destroy",
            value: function () {
              var t = this;
              return new f(function (e) {
                E.delete(t),
                  k.delete(t.element),
                  t._originalElement &&
                    (k.delete(t._originalElement),
                    t._originalElement.removeAttribute(
                      "data-vimeo-initialized"
                    )),
                  t.element &&
                    "IFRAME" === t.element.nodeName &&
                    t.element.parentNode &&
                    t.element.parentNode.removeChild(t.element),
                  e();
              });
            },
          },
          {
            key: "getAutopause",
            value: function () {
              return this.get("autopause");
            },
          },
          {
            key: "setAutopause",
            value: function (e) {
              return this.set("autopause", e);
            },
          },
          {
            key: "getBuffered",
            value: function () {
              return this.get("buffered");
            },
          },
          {
            key: "getColor",
            value: function () {
              return this.get("color");
            },
          },
          {
            key: "setColor",
            value: function (e) {
              return this.set("color", e);
            },
          },
          {
            key: "getCuePoints",
            value: function () {
              return this.get("cuePoints");
            },
          },
          {
            key: "getCurrentTime",
            value: function () {
              return this.get("currentTime");
            },
          },
          {
            key: "setCurrentTime",
            value: function (e) {
              return this.set("currentTime", e);
            },
          },
          {
            key: "getDuration",
            value: function () {
              return this.get("duration");
            },
          },
          {
            key: "getEnded",
            value: function () {
              return this.get("ended");
            },
          },
          {
            key: "getLoop",
            value: function () {
              return this.get("loop");
            },
          },
          {
            key: "setLoop",
            value: function (e) {
              return this.set("loop", e);
            },
          },
          {
            key: "setMuted",
            value: function (e) {
              return this.set("muted", e);
            },
          },
          {
            key: "getMuted",
            value: function () {
              return this.get("muted");
            },
          },
          {
            key: "getPaused",
            value: function () {
              return this.get("paused");
            },
          },
          {
            key: "getPlaybackRate",
            value: function () {
              return this.get("playbackRate");
            },
          },
          {
            key: "setPlaybackRate",
            value: function (e) {
              return this.set("playbackRate", e);
            },
          },
          {
            key: "getPlayed",
            value: function () {
              return this.get("played");
            },
          },
          {
            key: "getSeekable",
            value: function () {
              return this.get("seekable");
            },
          },
          {
            key: "getSeeking",
            value: function () {
              return this.get("seeking");
            },
          },
          {
            key: "getTextTracks",
            value: function () {
              return this.get("textTracks");
            },
          },
          {
            key: "getVideoEmbedCode",
            value: function () {
              return this.get("videoEmbedCode");
            },
          },
          {
            key: "getVideoId",
            value: function () {
              return this.get("videoId");
            },
          },
          {
            key: "getVideoTitle",
            value: function () {
              return this.get("videoTitle");
            },
          },
          {
            key: "getVideoWidth",
            value: function () {
              return this.get("videoWidth");
            },
          },
          {
            key: "getVideoHeight",
            value: function () {
              return this.get("videoHeight");
            },
          },
          {
            key: "getVideoUrl",
            value: function () {
              return this.get("videoUrl");
            },
          },
          {
            key: "getVolume",
            value: function () {
              return this.get("volume");
            },
          },
          {
            key: "setVolume",
            value: function (e) {
              return this.set("volume", e);
            },
          },
        ]) && r(e.prototype, t),
        n && r(e, n),
        Player
      );
    })();
  return (
    e ||
      ((function () {
        var e =
            0 < arguments.length && void 0 !== arguments[0]
              ? arguments[0]
              : document,
          t = [].slice.call(
            e.querySelectorAll("[data-vimeo-id], [data-vimeo-url]")
          ),
          n = function (e) {
            "console" in window &&
              console.error &&
              console.error("There was an error creating an embed: ".concat(e));
          };
        t.forEach(function (t) {
          try {
            if (null !== t.getAttribute("data-vimeo-defer")) return;
            var e = p(t);
            m(l(e), e, t)
              .then(function (e) {
                return y(e, t);
              })
              .catch(n);
          } catch (e) {
            n(e);
          }
        });
      })(),
      (function () {
        var r =
          0 < arguments.length && void 0 !== arguments[0]
            ? arguments[0]
            : document;
        if (!window.VimeoPlayerResizeEmbeds_) {
          window.VimeoPlayerResizeEmbeds_ = !0;
          var e = function (e) {
            if (s(e.origin) && e.data && "spacechange" === e.data.event)
              for (
                var t = r.querySelectorAll("iframe"), n = 0;
                n < t.length;
                n++
              )
                if (t[n].contentWindow === e.source) {
                  t[n].parentElement.style.paddingBottom = "".concat(
                    e.data.data[0].bottom,
                    "px"
                  );
                  break;
                }
          };
          window.addEventListener
            ? window.addEventListener("message", e, !1)
            : window.attachEvent && window.attachEvent("onmessage", e);
        }
      })()),
    Player
  );
});

//siema vanilla script slider
!(function (e, t) {
  "object" == typeof exports && "object" == typeof module
    ? (module.exports = t())
    : "function" == typeof define && define.amd
    ? define("Siema", [], t)
    : "object" == typeof exports
    ? (exports.Siema = t())
    : (e.Siema = t());
})("undefined" != typeof self ? self : this, function () {
  return (function (e) {
    function t(r) {
      if (i[r]) return i[r].exports;
      var n = (i[r] = { i: r, l: !1, exports: {} });
      return e[r].call(n.exports, n, n.exports, t), (n.l = !0), n.exports;
    }
    var i = {};
    return (
      (t.m = e),
      (t.c = i),
      (t.d = function (e, i, r) {
        t.o(e, i) ||
          Object.defineProperty(e, i, {
            configurable: !1,
            enumerable: !0,
            get: r,
          });
      }),
      (t.n = function (e) {
        var i =
          e && e.__esModule
            ? function () {
                return e.default;
              }
            : function () {
                return e;
              };
        return t.d(i, "a", i), i;
      }),
      (t.o = function (e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
      }),
      (t.p = ""),
      t((t.s = 0))
    );
  })([
    function (e, t, i) {
      "use strict";
      function r(e, t) {
        if (!(e instanceof t))
          throw new TypeError("Cannot call a class as a function");
      }
      Object.defineProperty(t, "__esModule", { value: !0 });
      var n =
          "function" == typeof Symbol && "symbol" == typeof Symbol.iterator
            ? function (e) {
                return typeof e;
              }
            : function (e) {
                return e &&
                  "function" == typeof Symbol &&
                  e.constructor === Symbol &&
                  e !== Symbol.prototype
                  ? "symbol"
                  : typeof e;
              },
        s = (function () {
          function e(e, t) {
            for (var i = 0; i < t.length; i++) {
              var r = t[i];
              (r.enumerable = r.enumerable || !1),
                (r.configurable = !0),
                "value" in r && (r.writable = !0),
                Object.defineProperty(e, r.key, r);
            }
          }
          return function (t, i, r) {
            return i && e(t.prototype, i), r && e(t, r), t;
          };
        })(),
        l = (function () {
          function e(t) {
            var i = this;
            if (
              (r(this, e),
              (this.config = e.mergeSettings(t)),
              (this.selector =
                "string" == typeof this.config.selector
                  ? document.querySelector(this.config.selector)
                  : this.config.selector),
              null === this.selector)
            )
              throw new Error("Something wrong with your selector ðŸ˜­");
            this.resolveSlidesNumber(),
              (this.selectorWidth = this.selector.offsetWidth),
              (this.innerElements = [].slice.call(this.selector.children)),
              (this.currentSlide = this.config.loop
                ? this.config.startIndex % this.innerElements.length
                : Math.max(
                    0,
                    Math.min(
                      this.config.startIndex,
                      this.innerElements.length - this.perPage
                    )
                  )),
              (this.transformProperty = e.webkitOrNot()),
              [
                "resizeHandler",
                "touchstartHandler",
                "touchendHandler",
                "touchmoveHandler",
                "mousedownHandler",
                "mouseupHandler",
                "mouseleaveHandler",
                "mousemoveHandler",
                "clickHandler",
              ].forEach(function (e) {
                i[e] = i[e].bind(i);
              }),
              this.init();
          }
          return (
            s(
              e,
              [
                {
                  key: "attachEvents",
                  value: function () {
                    window.addEventListener("resize", this.resizeHandler),
                      this.config.draggable &&
                        ((this.pointerDown = !1),
                        (this.drag = {
                          startX: 0,
                          endX: 0,
                          startY: 0,
                          letItGo: null,
                          preventClick: !1,
                        }),
                        this.selector.addEventListener(
                          "touchstart",
                          this.touchstartHandler
                        ),
                        this.selector.addEventListener(
                          "touchend",
                          this.touchendHandler
                        ),
                        this.selector.addEventListener(
                          "touchmove",
                          this.touchmoveHandler
                        ),
                        this.selector.addEventListener(
                          "mousedown",
                          this.mousedownHandler
                        ),
                        this.selector.addEventListener(
                          "mouseup",
                          this.mouseupHandler
                        ),
                        this.selector.addEventListener(
                          "mouseleave",
                          this.mouseleaveHandler
                        ),
                        this.selector.addEventListener(
                          "mousemove",
                          this.mousemoveHandler
                        ),
                        this.selector.addEventListener(
                          "click",
                          this.clickHandler
                        ));
                  },
                },
                {
                  key: "detachEvents",
                  value: function () {
                    window.removeEventListener("resize", this.resizeHandler),
                      this.selector.removeEventListener(
                        "touchstart",
                        this.touchstartHandler
                      ),
                      this.selector.removeEventListener(
                        "touchend",
                        this.touchendHandler
                      ),
                      this.selector.removeEventListener(
                        "touchmove",
                        this.touchmoveHandler
                      ),
                      this.selector.removeEventListener(
                        "mousedown",
                        this.mousedownHandler
                      ),
                      this.selector.removeEventListener(
                        "mouseup",
                        this.mouseupHandler
                      ),
                      this.selector.removeEventListener(
                        "mouseleave",
                        this.mouseleaveHandler
                      ),
                      this.selector.removeEventListener(
                        "mousemove",
                        this.mousemoveHandler
                      ),
                      this.selector.removeEventListener(
                        "click",
                        this.clickHandler
                      );
                  },
                },
                {
                  key: "init",
                  value: function () {
                    this.attachEvents(),
                      (this.selector.style.overflow = "hidden"),
                      (this.selector.style.direction = this.config.rtl
                        ? "rtl"
                        : "ltr"),
                      this.buildSliderFrame(),
                      this.config.onInit.call(this);
                  },
                },
                {
                  key: "buildSliderFrame",
                  value: function () {
                    var e = this.selectorWidth / this.perPage,
                      t = this.config.loop
                        ? this.innerElements.length + 2 * this.perPage
                        : this.innerElements.length;
                    (this.sliderFrame = document.createElement("div")),
                      (this.sliderFrame.style.width = e * t + "px"),
                      this.enableTransition(),
                      this.config.draggable &&
                        (this.selector.style.cursor = "-webkit-grab");
                    var i = document.createDocumentFragment();
                    if (this.config.loop)
                      for (
                        var r = this.innerElements.length - this.perPage;
                        r < this.innerElements.length;
                        r++
                      ) {
                        var n = this.buildSliderFrameItem(
                          this.innerElements[r].cloneNode(!0)
                        );
                        i.appendChild(n);
                      }
                    for (var s = 0; s < this.innerElements.length; s++) {
                      var l = this.buildSliderFrameItem(this.innerElements[s]);
                      i.appendChild(l);
                    }
                    if (this.config.loop)
                      for (var o = 0; o < this.perPage; o++) {
                        var a = this.buildSliderFrameItem(
                          this.innerElements[o].cloneNode(!0)
                        );
                        i.appendChild(a);
                      }
                    this.sliderFrame.appendChild(i),
                      (this.selector.innerHTML = ""),
                      this.selector.appendChild(this.sliderFrame),
                      this.slideToCurrent();
                  },
                },
                {
                  key: "buildSliderFrameItem",
                  value: function (e) {
                    var t = document.createElement("div");
                    return (
                      (t.style.cssFloat = this.config.rtl ? "right" : "left"),
                      (t.style.float = this.config.rtl ? "right" : "left"),
                      (t.style.width =
                        (this.config.loop
                          ? 100 / (this.innerElements.length + 2 * this.perPage)
                          : 100 / this.innerElements.length) + "%"),
                      t.appendChild(e),
                      t
                    );
                  },
                },
                {
                  key: "resolveSlidesNumber",
                  value: function () {
                    if ("number" == typeof this.config.perPage)
                      this.perPage = this.config.perPage;
                    else if ("object" === n(this.config.perPage)) {
                      this.perPage = 1;
                      for (var e in this.config.perPage)
                        window.innerWidth >= e &&
                          (this.perPage = this.config.perPage[e]);
                    }
                  },
                },
                {
                  key: "prev",
                  value: function () {
                    var e =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : 1,
                      t = arguments[1];
                    if (!(this.innerElements.length <= this.perPage)) {
                      var i = this.currentSlide;
                      if (this.config.loop) {
                        if (this.currentSlide - e < 0) {
                          this.disableTransition();
                          var r = this.currentSlide + this.innerElements.length,
                            n = this.perPage,
                            s = r + n,
                            l =
                              (this.config.rtl ? 1 : -1) *
                              s *
                              (this.selectorWidth / this.perPage),
                            o = this.config.draggable
                              ? this.drag.endX - this.drag.startX
                              : 0;
                          (this.sliderFrame.style[this.transformProperty] =
                            "translate3d(" + (l + o) + "px, 0, 0)"),
                            (this.currentSlide = r - e);
                        } else this.currentSlide = this.currentSlide - e;
                      } else
                        this.currentSlide = Math.max(this.currentSlide - e, 0);
                      i !== this.currentSlide &&
                        (this.slideToCurrent(this.config.loop),
                        this.config.onChange.call(this),
                        t && t.call(this));
                    }
                  },
                },
                {
                  key: "next",
                  value: function () {
                    var e =
                        arguments.length > 0 && void 0 !== arguments[0]
                          ? arguments[0]
                          : 1,
                      t = arguments[1];
                    if (!(this.innerElements.length <= this.perPage)) {
                      var i = this.currentSlide;
                      if (this.config.loop) {
                        if (
                          this.currentSlide + e >
                          this.innerElements.length - this.perPage
                        ) {
                          this.disableTransition();
                          var r = this.currentSlide - this.innerElements.length,
                            n = this.perPage,
                            s = r + n,
                            l =
                              (this.config.rtl ? 1 : -1) *
                              s *
                              (this.selectorWidth / this.perPage),
                            o = this.config.draggable
                              ? this.drag.endX - this.drag.startX
                              : 0;
                          (this.sliderFrame.style[this.transformProperty] =
                            "translate3d(" + (l + o) + "px, 0, 0)"),
                            (this.currentSlide = r + e);
                        } else this.currentSlide = this.currentSlide + e;
                      } else
                        this.currentSlide = Math.min(
                          this.currentSlide + e,
                          this.innerElements.length - this.perPage
                        );
                      i !== this.currentSlide &&
                        (this.slideToCurrent(this.config.loop),
                        this.config.onChange.call(this),
                        t && t.call(this));
                    }
                  },
                },
                {
                  key: "disableTransition",
                  value: function () {
                    (this.sliderFrame.style.webkitTransition =
                      "all 0ms " + this.config.easing),
                      (this.sliderFrame.style.transition =
                        "all 0ms " + this.config.easing);
                  },
                },
                {
                  key: "enableTransition",
                  value: function () {
                    (this.sliderFrame.style.webkitTransition =
                      "all " +
                      this.config.duration +
                      "ms " +
                      this.config.easing),
                      (this.sliderFrame.style.transition =
                        "all " +
                        this.config.duration +
                        "ms " +
                        this.config.easing);
                  },
                },
                {
                  key: "goTo",
                  value: function (e, t) {
                    if (!(this.innerElements.length <= this.perPage)) {
                      var i = this.currentSlide;
                      (this.currentSlide = this.config.loop
                        ? e % this.innerElements.length
                        : Math.min(
                            Math.max(e, 0),
                            this.innerElements.length - this.perPage
                          )),
                        i !== this.currentSlide &&
                          (this.slideToCurrent(),
                          this.config.onChange.call(this),
                          t && t.call(this));
                    }
                  },
                },
                {
                  key: "slideToCurrent",
                  value: function (e) {
                    var t = this,
                      i = this.config.loop
                        ? this.currentSlide + this.perPage
                        : this.currentSlide,
                      r =
                        (this.config.rtl ? 1 : -1) *
                        i *
                        (this.selectorWidth / this.perPage);
                    e
                      ? requestAnimationFrame(function () {
                          requestAnimationFrame(function () {
                            t.enableTransition(),
                              (t.sliderFrame.style[t.transformProperty] =
                                "translate3d(" + r + "px, 0, 0)");
                          });
                        })
                      : (this.sliderFrame.style[this.transformProperty] =
                          "translate3d(" + r + "px, 0, 0)");
                  },
                },
                {
                  key: "updateAfterDrag",
                  value: function () {
                    var e =
                        (this.config.rtl ? -1 : 1) *
                        (this.drag.endX - this.drag.startX),
                      t = Math.abs(e),
                      i = this.config.multipleDrag
                        ? Math.ceil(t / (this.selectorWidth / this.perPage))
                        : 1,
                      r = e > 0 && this.currentSlide - i < 0,
                      n =
                        e < 0 &&
                        this.currentSlide + i >
                          this.innerElements.length - this.perPage;
                    e > 0 &&
                    t > this.config.threshold &&
                    this.innerElements.length > this.perPage
                      ? this.prev(i)
                      : e < 0 &&
                        t > this.config.threshold &&
                        this.innerElements.length > this.perPage &&
                        this.next(i),
                      this.slideToCurrent(r || n);
                  },
                },
                {
                  key: "resizeHandler",
                  value: function () {
                    this.resolveSlidesNumber(),
                      this.currentSlide + this.perPage >
                        this.innerElements.length &&
                        (this.currentSlide =
                          this.innerElements.length <= this.perPage
                            ? 0
                            : this.innerElements.length - this.perPage),
                      (this.selectorWidth = this.selector.offsetWidth),
                      this.buildSliderFrame();
                  },
                },
                {
                  key: "clearDrag",
                  value: function () {
                    this.drag = {
                      startX: 0,
                      endX: 0,
                      startY: 0,
                      letItGo: null,
                      preventClick: this.drag.preventClick,
                    };
                  },
                },
                {
                  key: "touchstartHandler",
                  value: function (e) {
                    -1 !==
                      ["TEXTAREA", "OPTION", "INPUT", "SELECT"].indexOf(
                        e.target.nodeName
                      ) ||
                      (e.stopPropagation(),
                      (this.pointerDown = !0),
                      (this.drag.startX = e.touches[0].pageX),
                      (this.drag.startY = e.touches[0].pageY));
                  },
                },
                {
                  key: "touchendHandler",
                  value: function (e) {
                    e.stopPropagation(),
                      (this.pointerDown = !1),
                      this.enableTransition(),
                      this.drag.endX && this.updateAfterDrag(),
                      this.clearDrag();
                  },
                },
                {
                  key: "touchmoveHandler",
                  value: function (e) {
                    if (
                      (e.stopPropagation(),
                      null === this.drag.letItGo &&
                        (this.drag.letItGo =
                          Math.abs(this.drag.startY - e.touches[0].pageY) <
                          Math.abs(this.drag.startX - e.touches[0].pageX)),
                      this.pointerDown && this.drag.letItGo)
                    ) {
                      e.preventDefault(),
                        (this.drag.endX = e.touches[0].pageX),
                        (this.sliderFrame.style.webkitTransition =
                          "all 0ms " + this.config.easing),
                        (this.sliderFrame.style.transition =
                          "all 0ms " + this.config.easing);
                      var t = this.config.loop
                          ? this.currentSlide + this.perPage
                          : this.currentSlide,
                        i = t * (this.selectorWidth / this.perPage),
                        r = this.drag.endX - this.drag.startX,
                        n = this.config.rtl ? i + r : i - r;
                      this.sliderFrame.style[this.transformProperty] =
                        "translate3d(" +
                        (this.config.rtl ? 1 : -1) * n +
                        "px, 0, 0)";
                    }
                  },
                },
                {
                  key: "mousedownHandler",
                  value: function (e) {
                    -1 !==
                      ["TEXTAREA", "OPTION", "INPUT", "SELECT"].indexOf(
                        e.target.nodeName
                      ) ||
                      (e.preventDefault(),
                      e.stopPropagation(),
                      (this.pointerDown = !0),
                      (this.drag.startX = e.pageX));
                  },
                },
                {
                  key: "mouseupHandler",
                  value: function (e) {
                    e.stopPropagation(),
                      (this.pointerDown = !1),
                      (this.selector.style.cursor = "-webkit-grab"),
                      this.enableTransition(),
                      this.drag.endX && this.updateAfterDrag(),
                      this.clearDrag();
                  },
                },
                {
                  key: "mousemoveHandler",
                  value: function (e) {
                    if ((e.preventDefault(), this.pointerDown)) {
                      "A" === e.target.nodeName &&
                        (this.drag.preventClick = !0),
                        (this.drag.endX = e.pageX),
                        (this.selector.style.cursor = "-webkit-grabbing"),
                        (this.sliderFrame.style.webkitTransition =
                          "all 0ms " + this.config.easing),
                        (this.sliderFrame.style.transition =
                          "all 0ms " + this.config.easing);
                      var t = this.config.loop
                          ? this.currentSlide + this.perPage
                          : this.currentSlide,
                        i = t * (this.selectorWidth / this.perPage),
                        r = this.drag.endX - this.drag.startX,
                        n = this.config.rtl ? i + r : i - r;
                      this.sliderFrame.style[this.transformProperty] =
                        "translate3d(" +
                        (this.config.rtl ? 1 : -1) * n +
                        "px, 0, 0)";
                    }
                  },
                },
                {
                  key: "mouseleaveHandler",
                  value: function (e) {
                    this.pointerDown &&
                      ((this.pointerDown = !1),
                      (this.selector.style.cursor = "-webkit-grab"),
                      (this.drag.endX = e.pageX),
                      (this.drag.preventClick = !1),
                      this.enableTransition(),
                      this.updateAfterDrag(),
                      this.clearDrag());
                  },
                },
                {
                  key: "clickHandler",
                  value: function (e) {
                    this.drag.preventClick && e.preventDefault(),
                      (this.drag.preventClick = !1);
                  },
                },
                {
                  key: "remove",
                  value: function (e, t) {
                    if (e < 0 || e >= this.innerElements.length)
                      throw new Error("Item to remove doesn't exist ðŸ˜­");
                    var i = e < this.currentSlide,
                      r = this.currentSlide + this.perPage - 1 === e;
                    (i || r) && this.currentSlide--,
                      this.innerElements.splice(e, 1),
                      this.buildSliderFrame(),
                      t && t.call(this);
                  },
                },
                {
                  key: "insert",
                  value: function (e, t, i) {
                    if (t < 0 || t > this.innerElements.length + 1)
                      throw new Error("Unable to inset it at this index ðŸ˜­");
                    if (-1 !== this.innerElements.indexOf(e))
                      throw new Error(
                        "The same item in a carousel? Really? Nope ðŸ˜­"
                      );
                    var r =
                      t <= this.currentSlide > 0 && this.innerElements.length;
                    (this.currentSlide = r
                      ? this.currentSlide + 1
                      : this.currentSlide),
                      this.innerElements.splice(t, 0, e),
                      this.buildSliderFrame(),
                      i && i.call(this);
                  },
                },
                {
                  key: "prepend",
                  value: function (e, t) {
                    this.insert(e, 0), t && t.call(this);
                  },
                },
                {
                  key: "append",
                  value: function (e, t) {
                    this.insert(e, this.innerElements.length + 1),
                      t && t.call(this);
                  },
                },
                {
                  key: "destroy",
                  value: function () {
                    var e =
                        arguments.length > 0 &&
                        void 0 !== arguments[0] &&
                        arguments[0],
                      t = arguments[1];
                    if (
                      (this.detachEvents(),
                      (this.selector.style.cursor = "auto"),
                      e)
                    ) {
                      for (
                        var i = document.createDocumentFragment(), r = 0;
                        r < this.innerElements.length;
                        r++
                      )
                        i.appendChild(this.innerElements[r]);
                      (this.selector.innerHTML = ""),
                        this.selector.appendChild(i),
                        this.selector.removeAttribute("style");
                    }
                    t && t.call(this);
                  },
                },
              ],
              [
                {
                  key: "mergeSettings",
                  value: function (e) {
                    var t = {
                        selector: ".siema",
                        duration: 200,
                        easing: "ease-out",
                        perPage: 1,
                        startIndex: 0,
                        draggable: !0,
                        multipleDrag: !0,
                        threshold: 20,
                        loop: !1,
                        rtl: !1,
                        onInit: function () {},
                        onChange: function () {},
                      },
                      i = e;
                    for (var r in i) t[r] = i[r];
                    return t;
                  },
                },
                {
                  key: "webkitOrNot",
                  value: function () {
                    return "string" ==
                      typeof document.documentElement.style.transform
                      ? "transform"
                      : "WebkitTransform";
                  },
                },
              ]
            ),
            e
          );
        })();
      (t.default = l), (e.exports = t.default);
    },
  ]);
});

/**
 * Minified by jsDelivr using Terser v3.14.1.
 * Original file: /npm/js-cookie@2.2.0/src/js.cookie.js
 *
 * Do NOT use SRI with dynamically generated files! More information: https://www.jsdelivr.com/using-sri-with-dynamic-files
 */
!(function (e) {
  var n = !1;
  if (
    ("function" == typeof define && define.amd && (define(e), (n = !0)),
    "object" == typeof exports && ((module.exports = e()), (n = !0)),
    !n)
  ) {
    var o = window.Cookies,
      t = (window.Cookies = e());
    t.noConflict = function () {
      return (window.Cookies = o), t;
    };
  }
})(function () {
  function e() {
    for (var e = 0, n = {}; e < arguments.length; e++) {
      var o = arguments[e];
      for (var t in o) n[t] = o[t];
    }
    return n;
  }
  return (function n(o) {
    function t(n, r, i) {
      var c;
      if ("undefined" != typeof document) {
        if (arguments.length > 1) {
          if (
            "number" == typeof (i = e({ path: "/" }, t.defaults, i)).expires
          ) {
            var a = new Date();
            a.setMilliseconds(a.getMilliseconds() + 864e5 * i.expires),
              (i.expires = a);
          }
          i.expires = i.expires ? i.expires.toUTCString() : "";
          try {
            (c = JSON.stringify(r)), /^[\{\[]/.test(c) && (r = c);
          } catch (e) {}
          (r = o.write
            ? o.write(r, n)
            : encodeURIComponent(String(r)).replace(
                /%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g,
                decodeURIComponent
              )),
            (n = (n = (n = encodeURIComponent(String(n))).replace(
              /%(23|24|26|2B|5E|60|7C)/g,
              decodeURIComponent
            )).replace(/[\(\)]/g, escape));
          var s = "";
          for (var f in i)
            i[f] && ((s += "; " + f), !0 !== i[f] && (s += "=" + i[f]));
          return (document.cookie = n + "=" + r + s);
        }
        n || (c = {});
        for (
          var p = document.cookie ? document.cookie.split("; ") : [],
            d = /(%[0-9A-Z]{2})+/g,
            u = 0;
          u < p.length;
          u++
        ) {
          var l = p[u].split("="),
            C = l.slice(1).join("=");
          this.json || '"' !== C.charAt(0) || (C = C.slice(1, -1));
          try {
            var g = l[0].replace(d, decodeURIComponent);
            if (
              ((C = o.read
                ? o.read(C, g)
                : o(C, g) || C.replace(d, decodeURIComponent)),
              this.json)
            )
              try {
                C = JSON.parse(C);
              } catch (e) {}
            if (n === g) {
              c = C;
              break;
            }
            n || (c[g] = C);
          } catch (e) {}
        }
        return c;
      }
    }
    return (
      (t.set = t),
      (t.get = function (e) {
        return t.call(t, e);
      }),
      (t.getJSON = function () {
        return t.apply({ json: !0 }, [].slice.call(arguments));
      }),
      (t.defaults = {}),
      (t.remove = function (n, o) {
        t(n, "", e(o, { expires: -1 }));
      }),
      (t.withConverter = n),
      t
    );
  })(function () {});
});

/*!
 * imagesLoaded PACKAGED v4.1.3
 * JavaScript is all like "You images are done yet or what?"
 * MIT License
 */
!(function (e, t) {
  "function" == typeof define && define.amd
    ? define("ev-emitter/ev-emitter", t)
    : "object" == typeof module && module.exports
    ? (module.exports = t())
    : (e.EvEmitter = t());
})("undefined" != typeof window ? window : this, function () {
  function e() {}
  var t = e.prototype;
  return (
    (t.on = function (e, t) {
      if (e && t) {
        var i = (this._events = this._events || {}),
          n = (i[e] = i[e] || []);
        return -1 == n.indexOf(t) && n.push(t), this;
      }
    }),
    (t.once = function (e, t) {
      if (e && t) {
        this.on(e, t);
        var i = (this._onceEvents = this._onceEvents || {}),
          n = (i[e] = i[e] || {});
        return (n[t] = !0), this;
      }
    }),
    (t.off = function (e, t) {
      var i = this._events && this._events[e];
      if (i && i.length) {
        var n = i.indexOf(t);
        return -1 != n && i.splice(n, 1), this;
      }
    }),
    (t.emitEvent = function (e, t) {
      var i = this._events && this._events[e];
      if (i && i.length) {
        var n = 0,
          o = i[n];
        t = t || [];
        for (var r = this._onceEvents && this._onceEvents[e]; o; ) {
          var s = r && r[o];
          s && (this.off(e, o), delete r[o]),
            o.apply(this, t),
            (n += s ? 0 : 1),
            (o = i[n]);
        }
        return this;
      }
    }),
    (t.allOff = t.removeAllListeners =
      function () {
        delete this._events, delete this._onceEvents;
      }),
    e
  );
}),
  (function (e, t) {
    "use strict";
    "function" == typeof define && define.amd
      ? define(["ev-emitter/ev-emitter"], function (i) {
          return t(e, i);
        })
      : "object" == typeof module && module.exports
      ? (module.exports = t(e, require("ev-emitter")))
      : (e.imagesLoaded = t(e, e.EvEmitter));
  })("undefined" != typeof window ? window : this, function (e, t) {
    function i(e, t) {
      for (var i in t) e[i] = t[i];
      return e;
    }
    function n(e) {
      var t = [];
      if (Array.isArray(e)) t = e;
      else if ("number" == typeof e.length)
        for (var i = 0; i < e.length; i++) t.push(e[i]);
      else t.push(e);
      return t;
    }
    function o(e, t, r) {
      return this instanceof o
        ? ("string" == typeof e && (e = document.querySelectorAll(e)),
          (this.elements = n(e)),
          (this.options = i({}, this.options)),
          "function" == typeof t ? (r = t) : i(this.options, t),
          r && this.on("always", r),
          this.getImages(),
          h && (this.jqDeferred = new h.Deferred()),
          void setTimeout(
            function () {
              this.check();
            }.bind(this)
          ))
        : new o(e, t, r);
    }
    function r(e) {
      this.img = e;
    }
    function s(e, t) {
      (this.url = e), (this.element = t), (this.img = new Image());
    }
    var h = e.jQuery,
      a = e.console;
    (o.prototype = Object.create(t.prototype)),
      (o.prototype.options = {}),
      (o.prototype.getImages = function () {
        (this.images = []), this.elements.forEach(this.addElementImages, this);
      }),
      (o.prototype.addElementImages = function (e) {
        "IMG" == e.nodeName && this.addImage(e),
          this.options.background === !0 && this.addElementBackgroundImages(e);
        var t = e.nodeType;
        if (t && d[t]) {
          for (var i = e.querySelectorAll("img"), n = 0; n < i.length; n++) {
            var o = i[n];
            this.addImage(o);
          }
          if ("string" == typeof this.options.background) {
            var r = e.querySelectorAll(this.options.background);
            for (n = 0; n < r.length; n++) {
              var s = r[n];
              this.addElementBackgroundImages(s);
            }
          }
        }
      });
    var d = { 1: !0, 9: !0, 11: !0 };
    return (
      (o.prototype.addElementBackgroundImages = function (e) {
        var t = getComputedStyle(e);
        if (t)
          for (
            var i = /url\((['"])?(.*?)\1\)/gi, n = i.exec(t.backgroundImage);
            null !== n;

          ) {
            var o = n && n[2];
            o && this.addBackground(o, e), (n = i.exec(t.backgroundImage));
          }
      }),
      (o.prototype.addImage = function (e) {
        var t = new r(e);
        this.images.push(t);
      }),
      (o.prototype.addBackground = function (e, t) {
        var i = new s(e, t);
        this.images.push(i);
      }),
      (o.prototype.check = function () {
        function e(e, i, n) {
          setTimeout(function () {
            t.progress(e, i, n);
          });
        }
        var t = this;
        return (
          (this.progressedCount = 0),
          (this.hasAnyBroken = !1),
          this.images.length
            ? void this.images.forEach(function (t) {
                t.once("progress", e), t.check();
              })
            : void this.complete()
        );
      }),
      (o.prototype.progress = function (e, t, i) {
        this.progressedCount++,
          (this.hasAnyBroken = this.hasAnyBroken || !e.isLoaded),
          this.emitEvent("progress", [this, e, t]),
          this.jqDeferred &&
            this.jqDeferred.notify &&
            this.jqDeferred.notify(this, e),
          this.progressedCount == this.images.length && this.complete(),
          this.options.debug && a && a.log("progress: " + i, e, t);
      }),
      (o.prototype.complete = function () {
        var e = this.hasAnyBroken ? "fail" : "done";
        if (
          ((this.isComplete = !0),
          this.emitEvent(e, [this]),
          this.emitEvent("always", [this]),
          this.jqDeferred)
        ) {
          var t = this.hasAnyBroken ? "reject" : "resolve";
          this.jqDeferred[t](this);
        }
      }),
      (r.prototype = Object.create(t.prototype)),
      (r.prototype.check = function () {
        var e = this.getIsImageComplete();
        return e
          ? void this.confirm(0 !== this.img.naturalWidth, "naturalWidth")
          : ((this.proxyImage = new Image()),
            this.proxyImage.addEventListener("load", this),
            this.proxyImage.addEventListener("error", this),
            this.img.addEventListener("load", this),
            this.img.addEventListener("error", this),
            void (this.proxyImage.src = this.img.src));
      }),
      (r.prototype.getIsImageComplete = function () {
        return this.img.complete && void 0 !== this.img.naturalWidth;
      }),
      (r.prototype.confirm = function (e, t) {
        (this.isLoaded = e), this.emitEvent("progress", [this, this.img, t]);
      }),
      (r.prototype.handleEvent = function (e) {
        var t = "on" + e.type;
        this[t] && this[t](e);
      }),
      (r.prototype.onload = function () {
        this.confirm(!0, "onload"), this.unbindEvents();
      }),
      (r.prototype.onerror = function () {
        this.confirm(!1, "onerror"), this.unbindEvents();
      }),
      (r.prototype.unbindEvents = function () {
        this.proxyImage.removeEventListener("load", this),
          this.proxyImage.removeEventListener("error", this),
          this.img.removeEventListener("load", this),
          this.img.removeEventListener("error", this);
      }),
      (s.prototype = Object.create(r.prototype)),
      (s.prototype.check = function () {
        this.img.addEventListener("load", this),
          this.img.addEventListener("error", this),
          (this.img.src = this.url);
        var e = this.getIsImageComplete();
        e &&
          (this.confirm(0 !== this.img.naturalWidth, "naturalWidth"),
          this.unbindEvents());
      }),
      (s.prototype.unbindEvents = function () {
        this.img.removeEventListener("load", this),
          this.img.removeEventListener("error", this);
      }),
      (s.prototype.confirm = function (e, t) {
        (this.isLoaded = e),
          this.emitEvent("progress", [this, this.element, t]);
      }),
      (o.makeJQueryPlugin = function (t) {
        (t = t || e.jQuery),
          t &&
            ((h = t),
            (h.fn.imagesLoaded = function (e, t) {
              var i = new o(this, e, t);
              return i.jqDeferred.promise(h(this));
            }));
      }),
      o.makeJQueryPlugin(),
      o
    );
  });

/*jshint ignore: end*/

/*! npm.im/object-fit-images 3.2.4 */
var objectFitImages = (function () {
  "use strict";

  var OFI = "fregante:object-fit-images";
  var propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
  var testImg =
    typeof Image === "undefined"
      ? { style: { "object-position": 1 } }
      : new Image();
  var supportsObjectFit = "object-fit" in testImg.style;
  var supportsObjectPosition = "object-position" in testImg.style;
  var supportsOFI = "background-size" in testImg.style;
  var supportsCurrentSrc = typeof testImg.currentSrc === "string";
  var nativeGetAttribute = testImg.getAttribute;
  var nativeSetAttribute = testImg.setAttribute;
  var autoModeEnabled = false;

  function createPlaceholder(w, h) {
    return (
      "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" +
      w +
      "' height='" +
      h +
      "'%3E%3C/svg%3E"
    );
  }

  function polyfillCurrentSrc(el) {
    if (el.srcset && !supportsCurrentSrc && window.picturefill) {
      var pf = window.picturefill._;
      // parse srcset with picturefill where currentSrc isn't available
      if (!el[pf.ns] || !el[pf.ns].evaled) {
        // force synchronous srcset parsing
        pf.fillImg(el, { reselect: true });
      }

      if (!el[pf.ns].curSrc) {
        // force picturefill to parse srcset
        el[pf.ns].supported = false;
        pf.fillImg(el, { reselect: true });
      }

      // retrieve parsed currentSrc, if any
      el.currentSrc = el[pf.ns].curSrc || el.src;
    }
  }

  function getStyle(el) {
    var style = getComputedStyle(el).fontFamily;
    var parsed;
    var props = {};
    while ((parsed = propRegex.exec(style)) !== null) {
      props[parsed[1]] = parsed[2];
    }
    return props;
  }

  function setPlaceholder(img, width, height) {
    // Default: fill width, no height
    var placeholder = createPlaceholder(width || 1, height || 0);

    // Only set placeholder if it's different
    if (nativeGetAttribute.call(img, "src") !== placeholder) {
      nativeSetAttribute.call(img, "src", placeholder);
    }
  }

  function onImageReady(img, callback) {
    // naturalWidth is only available when the image headers are loaded,
    // this loop will poll it every 100ms.
    if (img.naturalWidth) {
      callback(img);
    } else {
      setTimeout(onImageReady, 100, img, callback);
    }
  }

  function fixOne(el) {
    var style = getStyle(el);
    var ofi = el[OFI];
    style["object-fit"] = style["object-fit"] || "fill"; // default value

    // Avoid running where unnecessary, unless OFI had already done its deed
    if (!ofi.img) {
      // fill is the default behavior so no action is necessary
      if (style["object-fit"] === "fill") {
        return;
      }

      // Where object-fit is supported and object-position isn't (Safari < 10)
      if (
        !ofi.skipTest && // unless user wants to apply regardless of browser support
        supportsObjectFit && // if browser already supports object-fit
        !style["object-position"] // unless object-position is used
      ) {
        return;
      }
    }

    // keep a clone in memory while resetting the original to a blank
    if (!ofi.img) {
      ofi.img = new Image(el.width, el.height);
      ofi.img.srcset =
        nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
      ofi.img.src = nativeGetAttribute.call(el, "data-ofi-src") || el.src;

      // preserve for any future cloneNode calls
      // https://github.com/fregante/object-fit-images/issues/53
      nativeSetAttribute.call(el, "data-ofi-src", el.src);
      if (el.srcset) {
        nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
      }

      setPlaceholder(
        el,
        el.naturalWidth || el.width,
        el.naturalHeight || el.height
      );

      // remove srcset because it overrides src
      if (el.srcset) {
        el.srcset = "";
      }
      try {
        keepSrcUsable(el);
      } catch (err) {
        if (window.console) {
          console.warn("https://bit.ly/ofi-old-browser");
        }
      }
    }

    polyfillCurrentSrc(ofi.img);

    el.style.backgroundImage =
      'url("' + (ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"') + '")';
    el.style.backgroundPosition = style["object-position"] || "center";
    el.style.backgroundRepeat = "no-repeat";
    el.style.backgroundOrigin = "content-box";

    if (/scale-down/.test(style["object-fit"])) {
      onImageReady(ofi.img, function () {
        if (
          ofi.img.naturalWidth > el.width ||
          ofi.img.naturalHeight > el.height
        ) {
          el.style.backgroundSize = "contain";
        } else {
          el.style.backgroundSize = "auto";
        }
      });
    } else {
      el.style.backgroundSize = style["object-fit"]
        .replace("none", "auto")
        .replace("fill", "100% 100%");
    }

    onImageReady(ofi.img, function (img) {
      setPlaceholder(el, img.naturalWidth, img.naturalHeight);
    });
  }

  function keepSrcUsable(el) {
    var descriptors = {
      get: function get(prop) {
        return el[OFI].img[prop ? prop : "src"];
      },
      set: function set(value, prop) {
        el[OFI].img[prop ? prop : "src"] = value;
        nativeSetAttribute.call(el, "data-ofi-" + prop, value); // preserve for any future cloneNode
        fixOne(el);
        return value;
      },
    };
    Object.defineProperty(el, "src", descriptors);
    Object.defineProperty(el, "currentSrc", {
      get: function () {
        return descriptors.get("currentSrc");
      },
    });
    Object.defineProperty(el, "srcset", {
      get: function () {
        return descriptors.get("srcset");
      },
      set: function (ss) {
        return descriptors.set(ss, "srcset");
      },
    });
  }

  function hijackAttributes() {
    function getOfiImageMaybe(el, name) {
      return el[OFI] && el[OFI].img && (name === "src" || name === "srcset")
        ? el[OFI].img
        : el;
    }
    if (!supportsObjectPosition) {
      HTMLImageElement.prototype.getAttribute = function (name) {
        return nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
      };

      HTMLImageElement.prototype.setAttribute = function (name, value) {
        return nativeSetAttribute.call(
          getOfiImageMaybe(this, name),
          name,
          String(value)
        );
      };
    }
  }

  function fix(imgs, opts) {
    var startAutoMode = !autoModeEnabled && !imgs;
    opts = opts || {};
    imgs = imgs || "img";

    if ((supportsObjectPosition && !opts.skipTest) || !supportsOFI) {
      return false;
    }

    // use imgs as a selector or just select all images
    if (imgs === "img") {
      imgs = document.getElementsByTagName("img");
    } else if (typeof imgs === "string") {
      imgs = document.querySelectorAll(imgs);
    } else if (!("length" in imgs)) {
      imgs = [imgs];
    }

    // apply fix to all
    for (var i = 0; i < imgs.length; i++) {
      imgs[i][OFI] = imgs[i][OFI] || {
        skipTest: opts.skipTest,
      };
      fixOne(imgs[i]);
    }

    if (startAutoMode) {
      document.body.addEventListener(
        "load",
        function (e) {
          if (e.target.tagName === "IMG") {
            fix(e.target, {
              skipTest: opts.skipTest,
            });
          }
        },
        true
      );
      autoModeEnabled = true;
      imgs = "img"; // reset to a generic selector for watchMQ
    }

    // if requested, watch media queries for object-fit change
    if (opts.watchMQ) {
      window.addEventListener(
        "resize",
        fix.bind(null, imgs, {
          skipTest: opts.skipTest,
        })
      );
    }
  }

  fix.supportsObjectFit = supportsObjectFit;
  fix.supportsObjectPosition = supportsObjectPosition;

  hijackAttributes();

  return fix;
})();
// Object Fit ends

//polyfill for es6 foreach
if ("NodeList" in window && !NodeList.prototype.forEach) {
  console.info("polyfill for IE11");
  NodeList.prototype.forEach = function (callback, thisArg) {
    thisArg = thisArg || window;
    for (var i = 0; i < this.length; i++) {
      callback.call(thisArg, this[i], i, this);
    }
  };
}

(function ($) {
  //global vars
  const html = document.querySelector("html"),
    body = html.querySelector("body"),
    headerWrapper = document.querySelector(".header--wrapper");
  var firstload = 1;

  //cookies
  const jsCookieAccept = function () {
    //Cookies.remove('acceptlongviewcookie');
    var cookieWrapper = document.querySelector(".module--cookie-notification");
    if (cookieWrapper) {
      var acceptButton = cookieWrapper.querySelector(".close");
      html.classList.add("is--cookie__notaccepted");
      acceptButton.addEventListener("click", function (e) {
        Cookies.set("acceptlongviewcookie", "1", { expires: 7 });
        //html.classList.add('is--cookie__accepted');
        html.classList.remove("is--cookie__notaccepted");
      });
      // cookieWrapper.addEventListener('click',function(e){
      //   e.stopPropagation();
      //   Cookies.set('acceptlongviewcookie', '1', { expires: 7 });
      //   //html.classList.add('is--cookie__accepted');
      //   html.classList.remove('is--cookie__notaccepted');
      // });

      if (Cookies.get("acceptlongviewcookie") === "1") {
        //html.classList.add('is--cookie__accepted');
        html.classList.remove("is--cookie__notaccepted");
      } else {
        //html.classList.remove('is--cookie__accepted');
        html.classList.add("is--cookie__notaccepted");
      }
    }
  };
  jsCookieAccept();

  //cookies
  const jsCookieNotification = function () {
    //Cookies.remove('acceptlongviewcookie');
    var cookieWrapper = document.querySelector(".module--notification");
    if (cookieWrapper) {
      var acceptButton = cookieWrapper.querySelector(".close");
      html.classList.add("is--notification__notaccepted");
      acceptButton.addEventListener("click", function (e) {
        Cookies.set("acceptlongviewnotify", "1", { expires: 7 });
        //html.classList.add('is--cookie__accepted');
        html.classList.remove("is--notification__notaccepted");
      });
      cookieWrapper.addEventListener("click", function (e) {
        e.stopPropagation();
        Cookies.set("acceptlongviewnotify", "1", { expires: 7 });
        //html.classList.add('is--cookie__accepted');
        html.classList.remove("is--notification__notaccepted");
      });

      if (Cookies.get("acceptlongviewnotify") === "1") {
        //html.classList.add('is--cookie__accepted');
        html.classList.remove("is--notification__notaccepted");
      } else {
        //html.classList.remove('is--cookie__accepted');
        html.classList.add("is--notification__notaccepted");
      }
    }
  };
  jsCookieNotification();

  // ########################################
  //  GLOBAL SCRIPTS - write scripts here to reload for ajax
  // ########################################

  // Fix Safari scrolling issue after ajax page load
  var customWheelHandler = null;

  function bindAjaxScrollbarWheel() {
    if (customWheelHandler) {
      window.removeEventListener("wheel", customWheelHandler, true);
    }

    customWheelHandler = function (event) {
      if (event.ctrlKey) return;

      var scrollArea = document.querySelector("#main--scrollbar");

      if (!scrollArea) return;

      var scrollbar = window.Scrollbar.get(scrollArea);

      if (!scrollbar) return;

      // Only handle wheel events occurring over the current scrollbar area.
      if (
        event.target instanceof Node &&
        !scrollArea.contains(event.target)
      ) {
        return;
      }

      var multiplier = 1;

      if (event.deltaMode === 1) {
        multiplier = 16;
      } else if (event.deltaMode === 2) {
        multiplier = window.innerHeight;
      }

      var nextX =
        scrollbar.offset.x + event.deltaX * multiplier;

      var nextY =
        scrollbar.offset.y + event.deltaY * multiplier;

      event.preventDefault();
      event.stopImmediatePropagation();

      // scrollbar.setPosition(nextX, nextY);

      // Activate this for smooth scrolling
      scrollbar.addTransformableMomentum(
        event.deltaX * multiplier,
        event.deltaY * multiplier,
        event
      );
    };

    window.addEventListener("wheel", customWheelHandler, {
      passive: false,
      capture: true
    });
  }

  const globalScripts = function (html, body, headerWrapper, firstload) {
    const mainWrapper = document.querySelector(".main"),
      moduleItems = mainWrapper.querySelectorAll(".module"),
      moduleGradientScroll = document.querySelector(
        ".header--gradient__scroller"
      ),
      moduleGradient = moduleGradientScroll.querySelector(".module--gradient"),
      headerGradient = document.querySelector(".header--gradient"),
      colorArray = [],
      moduleCount = moduleItems.length;

    //firm hero function
    var firmHero = document.querySelector(".module--firm-hero");
    var firmText = document.querySelector(".module--firm-hero__text .col");
    var firmHeroInit = function (hero, text) {
      if (hero && text) {
        setTimeout(function () {
          var firmPos = hero.offsetHeight - text.offsetHeight * 1.03;
          firmHeroInit = firmPos;
          //var firmPos = 1103;
          text.setAttribute(
            "style",
            "transform: scale(1) translateX(0) translateY(-" +
              firmPos +
              "px) translateZ(0);"
          );
          return firmHeroInit;
        }, 300);
      }
    };
    firmHeroInit(firmHero, firmText);
    if (firstload === 0) {
      window.addEventListener("load", function () {
        firmHeroInit(firmHero, firmText);
      });
    }

    // var textOverlayWrapper = document.querySelector('.module--text-overlay__wrapper');
    // var textOverlayImage = document.querySelector('.module--text-overlay__image');
    // var textOverlayText = document.querySelector('.module--text-overlay__text .col');
    // var textOverlayInit = function(img,text){
    // 	if( img && text ){
    //  	setTimeout(function(){
    //  		var textOverlayPos = textOverlayImage.offsetHeight / 2 + textOverlayText.offsetHeight + 50;
    //  		textOverlayInit = textOverlayPos;
    //  		textOverlayWrapper.setAttribute('style','margin:'+ textOverlayText.offsetHeight +'px 0 0');
    //  		text.setAttribute('style','transform: scale(1) translateX(0) translateY(-'+ textOverlayPos +'px) translateZ(0);');
    //  		return textOverlayInit;
    //  	}, 900);
    // 	}
    // };
    // textOverlayInit(textOverlayImage,textOverlayText);
    // if ( firstload === 0 ){
    // 	window.addEventListener('load', function() {
    // 		textOverlayInit(textOverlayImage,textOverlayText);
    // 	});
    // }

    var textOverlayWrapper = document.querySelector(
      ".module--text-overlay__wrapper"
    );
    var textOverlayImage = document.querySelector(
      ".module--text-overlay__image"
    );
    var textOverlayText = document.querySelector(
      ".module--text-overlay__text .col"
    );
    var textOverlayInit = function (img, text) {
      if (img && text) {
        setTimeout(function () {
          var textOverlayPos =
            textOverlayImage.offsetHeight + textOverlayText.offsetHeight + 50;
          textOverlayInit = textOverlayPos;
          textOverlayWrapper.setAttribute(
            "style",
            "margin:" + textOverlayText.offsetHeight + "px 0 0"
          );
          text.setAttribute(
            "style",
            "transform: scale(1) translateX(0) translateY(-" +
              textOverlayPos +
              "px) translateZ(0);"
          );
          return textOverlayInit;
        }, 300);
      }
    };
    textOverlayInit(textOverlayImage, textOverlayText);
    if (firstload === 0) {
      window.addEventListener("load", function () {
        textOverlayInit(textOverlayImage, textOverlayText);
      });
    }

    const gradientBG = function () {
      //gradient bg by data-attrib
      const mainWrapper = document.querySelector(".main"),
        moduleItems = mainWrapper.querySelectorAll(".module"),
        moduleGradient = document.querySelector(".module--gradient"),
        colorArray = [],
        moduleCount = moduleItems.length;

      //set gradient
      setTimeout(function () {
        var gradientHeight =
          document.querySelector(".scroll-content").clientHeight;
        moduleItems.forEach(function (el, i) {
          var color = el.dataset.color,
            height = el.offsetTop + el.offsetHeight;

          if (color) {
            const colorheight = color + " " + height + "px";
            colorArray.push(colorheight);
          }
        });

        if (colorArray.length > 0) {
        const colorLast =
          colorArray.pop().split(" ")[0] + " " + gradientHeight + "px";
        colorArray.push(colorLast);

        if (moduleCount > 2) {
          moduleGradient.setAttribute(
            "style",
            "background: -webkit-linear-gradient(top, " +
              colorArray.join() +
              "); height: " +
              gradientHeight +
              "px;"
          );
          headerGradient.setAttribute(
            "style",
            "background: -webkit-linear-gradient(top, " +
              colorArray.join() +
              "); height: " +
              gradientHeight +
              "px;"
          );
          moduleGradient.setAttribute(
            "style",
            "background: linear-gradient(to bottom, " +
              colorArray.join() +
              "); height: " +
              gradientHeight +
              "px;"
          );
          headerGradient.setAttribute(
            "style",
            "background: linear-gradient(to bottom, " +
              colorArray.join() +
              "); height: " +
              gradientHeight +
              "px;"
          );
        } else {
          moduleGradient.setAttribute(
            "style",
            "background: " +
              colorArray.length > 0 ? colorArray[0].split(" ")[0] : "#ffffff" +
              "; height: " +
              gradientHeight +
              "px;"
          );
          headerGradient.setAttribute(
            "style",
            "background: " +
              colorArray.length > 0 ? colorArray[0].split(" ")[0] : "#ffffff" +
              "; height: " +
              gradientHeight +
              "px;"
          );
        }
        }
        html.classList.remove("is--first-load");
      }, 900);
    };

    if (firstload === 1) {
      // --- load only after dom and if initload
      window.addEventListener("load", function () {
        gradientBG();
      });
    } else {
      gradientBG();
    }

    //remember resize function fucks up ios *write fallback
    window.addEventListener("resize", function () {
      //clearTimeout(resizeId);
      setTimeout(function () {
        //reset firmhero
        var firmHero = document.querySelector(".module--firm-hero");
        var firmText = document.querySelector(".module--firm-hero__text .col");
        if (firmHero && firmText) {
          firmHeroInit = firmHero.offsetHeight - firmText.offsetHeight * 1.3;
          firmText.setAttribute(
            "style",
            "transform: scale(1) translateX(0) translateY(-" +
              firmHeroInit +
              "px) translateZ(0);"
          );
        }

        // var textOverlay = document.querySelector('.module--text-overlay');
        // var textOverlayImage = document.querySelector('.module--text-overlay__image');
        // var textOverlayText = document.querySelector('.module--text-overlay__text .col');
        // if( textOverlayImage && textOverlayText ){
        //   var textOverlayPos = textOverlayImage.offsetHeight / 2 + textOverlayText.offsetHeight + 50;
        //   textOverlayInit = textOverlayPos;
        //   textOverlayText.setAttribute('style','transform: scale(1) translateX(0) translateY(-'+ textOverlayPos +'px) translateZ(0);');
        // }

        var textOverlay = document.querySelector(".module--text-overlay");
        var textOverlayImage = document.querySelector(
          ".module--text-overlay__image"
        );
        var textOverlayText = document.querySelector(
          ".module--text-overlay__text .col"
        );
        if (textOverlayImage && textOverlayText) {
          var textOverlayPos =
            textOverlayImage.offsetHeight + textOverlayText.offsetHeight + 50;
          textOverlayInit = textOverlayPos;
          textOverlayText.setAttribute(
            "style",
            "transform: scale(1) translateX(0) translateY(-" +
              textOverlayPos +
              "px) translateZ(0);"
          );
        }

        gradientBG();
      }, 300);
    });

    //smooth scrollbar main
    const Scrollbar = window.Scrollbar,
      ScrollArea = document.querySelector("#main--scrollbar");
    var lastPosition = 0;

    //smooth scrollbar hero - feature is disabled - enable in css
    const moduleHero = document.querySelector(".module--hero");
    if (moduleHero) {
      var moduleHeroImage = moduleHero.querySelector(".module--hero__image");
      if (firstload === 1) {
        imagesLoaded(moduleHeroImage, function () {
          html.classList.add("is--loaded__hero");
          html.classList.add("hero-contrast");
        });
      }
    }

    var counter = 0;

    var ua = window.navigator.userAgent;
    var trident = ua.indexOf("Trident/");
    var firefox = navigator.userAgent.toLowerCase().indexOf("firefox");
    var edge = ua.indexOf("Edge/"); //|| firefox > -1;
    if (trident > 0 || edge > 0) {
      /*jshint ignore: start*/
      //# sourceMappingURL=SmoothScroll.min.js.map
      !(function () {
        var e,
          t,
          o,
          n,
          r = {
            frameRate: 150,
            animationTime: 400,
            stepSize: 100,
            pulseAlgorithm: !0,
            pulseScale: 4,
            pulseNormalize: 1,
            accelerationDelta: 50,
            accelerationMax: 3,
            keyboardSupport: !0,
            arrowScroll: 50,
            fixedBackground: !0,
            excluded: "",
          },
          a = r,
          l = !1,
          i = !1,
          c = { x: 0, y: 0 },
          u = !1,
          s = document.documentElement,
          d = [],
          f = /^Mac/.test(navigator.platform),
          m = {
            left: 37,
            up: 38,
            right: 39,
            down: 40,
            spacebar: 32,
            pageup: 33,
            pagedown: 34,
            end: 35,
            home: 36,
          },
          h = { 37: 1, 38: 1, 39: 1, 40: 1 };
        function w() {
          if (!u && document.body) {
            u = !0;
            var n = document.body,
              r = document.documentElement,
              c = window.innerHeight,
              d = n.scrollHeight;
            if (
              ((s = document.compatMode.indexOf("CSS") >= 0 ? r : n),
              (e = n),
              a.keyboardSupport && A("keydown", S),
              top != self)
            )
              i = !0;
            else if (
              Z &&
              d > c &&
              (n.offsetHeight <= c || r.offsetHeight <= c)
            ) {
              var f,
                m = document.createElement("div");
              (m.style.cssText =
                "position:absolute; z-index:-10000; top:0; left:0; right:0; height:" +
                s.scrollHeight +
                "px"),
                document.body.appendChild(m),
                (o = function () {
                  f ||
                    (f = setTimeout(function () {
                      l ||
                        ((m.style.height = "0"),
                        (m.style.height = s.scrollHeight + "px"),
                        (f = null));
                    }, 500));
                }),
                setTimeout(o, 10),
                A("resize", o);
              if (
                ((t = new q(o)).observe(n, {
                  attributes: !0,
                  childList: !0,
                  characterData: !1,
                }),
                s.offsetHeight <= c)
              ) {
                var h = document.createElement("div");
                (h.style.clear = "both"), n.appendChild(h);
              }
            }
            a.fixedBackground ||
              l ||
              ((n.style.backgroundAttachment = "scroll"),
              (r.style.backgroundAttachment = "scroll"));
          }
        }
        var p = [],
          v = !1,
          y = Date.now();
        function b(e, t, o) {
          var n, r;
          if (
            ((n = (n = t) > 0 ? 1 : -1),
            (r = (r = o) > 0 ? 1 : -1),
            (c.x !== n || c.y !== r) &&
              ((c.x = n), (c.y = r), (p = []), (y = 0)),
            1 != a.accelerationMax)
          ) {
            var l = Date.now() - y;
            if (l < a.accelerationDelta) {
              var i = (1 + 50 / l) / 2;
              i > 1 &&
                ((i = Math.min(i, a.accelerationMax)), (t *= i), (o *= i));
            }
            y = Date.now();
          }
          if (
            (p.push({
              x: t,
              y: o,
              lastX: t < 0 ? 0.99 : -0.99,
              lastY: o < 0 ? 0.99 : -0.99,
              start: Date.now(),
            }),
            !v)
          ) {
            var u = V(),
              s = e === u || e === document.body;
            null == e.$scrollBehavior &&
              (function (e) {
                var t = M(e);
                if (null == B[t]) {
                  var o = getComputedStyle(e, "")["scroll-behavior"];
                  B[t] = "smooth" == o;
                }
                return B[t];
              })(e) &&
              ((e.$scrollBehavior = e.style.scrollBehavior),
              (e.style.scrollBehavior = "auto"));
            var d = function (n) {
              for (var r = Date.now(), l = 0, i = 0, c = 0; c < p.length; c++) {
                var u = p[c],
                  f = r - u.start,
                  m = f >= a.animationTime,
                  h = m ? 1 : f / a.animationTime;
                a.pulseAlgorithm && (h = I(h));
                var w = (u.x * h - u.lastX) >> 0,
                  y = (u.y * h - u.lastY) >> 0;
                (l += w),
                  (i += y),
                  (u.lastX += w),
                  (u.lastY += y),
                  m && (p.splice(c, 1), c--);
              }
              s
                ? window.scrollBy(l, i)
                : (l && (e.scrollLeft += l), i && (e.scrollTop += i)),
                t || o || (p = []),
                p.length
                  ? R(d, e, 1e3 / a.frameRate + 1)
                  : ((v = !1),
                    null != e.$scrollBehavior &&
                      ((e.style.scrollBehavior = e.$scrollBehavior),
                      (e.$scrollBehavior = null)));
            };
            R(d, e, 0), (v = !0);
          }
        }
        function g(t) {
          u || w();
          var o = t.target;
          if (t.defaultPrevented || t.ctrlKey) return !0;
          if (
            K(e, "embed") ||
            (K(o, "embed") && /\.pdf/i.test(o.src)) ||
            K(e, "object") ||
            o.shadowRoot
          )
            return !0;
          var r = -t.wheelDeltaX || t.deltaX || 0,
            l = -t.wheelDeltaY || t.deltaY || 0;
          f &&
            (t.wheelDeltaX &&
              P(t.wheelDeltaX, 120) &&
              (r = (t.wheelDeltaX / Math.abs(t.wheelDeltaX)) * -120),
            t.wheelDeltaY &&
              P(t.wheelDeltaY, 120) &&
              (l = (t.wheelDeltaY / Math.abs(t.wheelDeltaY)) * -120)),
            r || l || (l = -t.wheelDelta || 0),
            1 === t.deltaMode && ((r *= 40), (l *= 40));
          var c = L(o);
          return c
            ? !!(function (e) {
                if (!e) return;
                d.length || (d = [e, e, e]);
                (e = Math.abs(e)),
                  d.push(e),
                  d.shift(),
                  clearTimeout(n),
                  (n = setTimeout(function () {
                    try {
                      localStorage.SS_deltaBuffer = d.join(",");
                    } catch (e) {}
                  }, 1e3));
                var t = e > 120 && $(e);
                return !$(120) && !$(100) && !t;
              })(l) ||
                (Math.abs(r) > 1.2 && (r *= a.stepSize / 120),
                Math.abs(l) > 1.2 && (l *= a.stepSize / 120),
                b(c, r, l),
                t.preventDefault(),
                void C())
            : !i ||
                !U ||
                (Object.defineProperty(t, "target", {
                  value: window.frameElement,
                }),
                parent.wheel(t));
        }
        function S(t) {
          var o = t.target,
            n =
              t.ctrlKey ||
              t.altKey ||
              t.metaKey ||
              (t.shiftKey && t.keyCode !== m.spacebar);
          document.body.contains(e) || (e = document.activeElement);
          var r = /^(button|submit|radio|checkbox|file|color|image)$/i;
          if (
            t.defaultPrevented ||
            /^(textarea|select|embed|object)$/i.test(o.nodeName) ||
            (K(o, "input") && !r.test(o.type)) ||
            K(e, "video") ||
            (function (e) {
              var t = e.target,
                o = !1;
              if (-1 != document.URL.indexOf("www.youtube.com/watch"))
                do {
                  if (
                    (o =
                      t.classList &&
                      t.classList.contains("html5-video-controls"))
                  )
                    break;
                } while ((t = t.parentNode));
              return o;
            })(t) ||
            o.isContentEditable ||
            n
          )
            return !0;
          if (
            (K(o, "button") || (K(o, "input") && r.test(o.type))) &&
            t.keyCode === m.spacebar
          )
            return !0;
          if (K(o, "input") && "radio" == o.type && h[t.keyCode]) return !0;
          var l = 0,
            c = 0,
            u = L(e);
          if (!u) return !i || !U || parent.keydown(t);
          var s = u.clientHeight;
          switch ((u == document.body && (s = window.innerHeight), t.keyCode)) {
            case m.up:
              c = -a.arrowScroll;
              break;
            case m.down:
              c = a.arrowScroll;
              break;
            case m.spacebar:
              c = -(t.shiftKey ? 1 : -1) * s * 0.9;
              break;
            case m.pageup:
              c = 0.9 * -s;
              break;
            case m.pagedown:
              c = 0.9 * s;
              break;
            case m.home:
              u == document.body &&
                document.scrollingElement &&
                (u = document.scrollingElement),
                (c = -u.scrollTop);
              break;
            case m.end:
              var d = u.scrollHeight - u.scrollTop - s;
              c = d > 0 ? d + 10 : 0;
              break;
            case m.left:
              l = -a.arrowScroll;
              break;
            case m.right:
              l = a.arrowScroll;
              break;
            default:
              return !0;
          }
          b(u, l, c), t.preventDefault(), C();
        }
        function x(t) {
          e = t.target;
        }
        var k,
          D,
          M =
            ((k = 0),
            function (e) {
              return e.uniqueID || (e.uniqueID = k++);
            }),
          E = {},
          T = {},
          B = {};
        function C() {
          clearTimeout(D),
            (D = setInterval(function () {
              E = T = B = {};
            }, 1e3));
        }
        function H(e, t, o) {
          for (var n = o ? E : T, r = e.length; r--; ) n[M(e[r])] = t;
          return t;
        }
        function z(e, t) {
          return (t ? E : T)[M(e)];
        }
        function L(e) {
          var t = [],
            o = document.body,
            n = s.scrollHeight;
          do {
            var r = z(e, !1);
            if (r) return H(t, r);
            if ((t.push(e), n === e.scrollHeight)) {
              var a = (X(s) && X(o)) || Y(s);
              if ((i && O(s)) || (!i && a)) return H(t, V());
            } else if (O(e) && Y(e)) return H(t, e);
          } while ((e = e.parentElement));
        }
        function O(e) {
          return e.clientHeight + 10 < e.scrollHeight;
        }
        function X(e) {
          return (
            "hidden" !== getComputedStyle(e, "").getPropertyValue("overflow-y")
          );
        }
        function Y(e) {
          var t = getComputedStyle(e, "").getPropertyValue("overflow-y");
          return "scroll" === t || "auto" === t;
        }
        function A(e, t, o) {
          window.addEventListener(e, t, o || !1);
        }
        function N(e, t, o) {
          window.removeEventListener(e, t, o || !1);
        }
        function K(e, t) {
          return e && (e.nodeName || "").toLowerCase() === t.toLowerCase();
        }
        if (window.localStorage && localStorage.SS_deltaBuffer)
          try {
            d = localStorage.SS_deltaBuffer.split(",");
          } catch (e) {}
        function P(e, t) {
          return Math.floor(e / t) == e / t;
        }
        function $(e) {
          return P(d[0], e) && P(d[1], e) && P(d[2], e);
        }
        var j,
          R =
            window.requestAnimationFrame ||
            window.webkitRequestAnimationFrame ||
            window.mozRequestAnimationFrame ||
            function (e, t, o) {
              window.setTimeout(e, o || 1e3 / 60);
            },
          q =
            window.MutationObserver ||
            window.WebKitMutationObserver ||
            window.MozMutationObserver,
          V =
            ((j = document.scrollingElement),
            function () {
              if (!j) {
                var e = document.createElement("div");
                (e.style.cssText = "height:10000px;width:1px;"),
                  document.body.appendChild(e);
                var t = document.body.scrollTop;
                document.documentElement.scrollTop,
                  window.scrollBy(0, 3),
                  (j =
                    document.body.scrollTop != t
                      ? document.body
                      : document.documentElement),
                  window.scrollBy(0, -3),
                  document.body.removeChild(e);
              }
              return j;
            });
        function F(e) {
          var t, o;
          return (
            (e *= a.pulseScale) < 1
              ? (t = e - (1 - Math.exp(-e)))
              : ((e -= 1),
                (t = (o = Math.exp(-1)) + (1 - Math.exp(-e)) * (1 - o))),
            t * a.pulseNormalize
          );
        }
        function I(e) {
          return e >= 1
            ? 1
            : e <= 0
            ? 0
            : (1 == a.pulseNormalize && (a.pulseNormalize /= F(1)), F(e));
        }
        var _ = window.navigator.userAgent,
          W = /Edge/.test(_),
          U = /chrome/i.test(_) && !W,
          G = /safari/i.test(_) && !W,
          J = /mobile/i.test(_),
          Q = /Windows NT 6.1/i.test(_) && /rv:11/i.test(_),
          Z = G && (/Version\/8/i.test(_) || /Version\/9/i.test(_)),
          ee = (U || G || Q) && !J,
          te = !1;
        try {
          window.addEventListener(
            "test",
            null,
            Object.defineProperty({}, "passive", {
              get: function () {
                te = !0;
              },
            })
          );
        } catch (e) {}
        var oe = !!te && { passive: !1 },
          ne =
            "onwheel" in document.createElement("div") ? "wheel" : "mousewheel";
        function re(e) {
          for (var t in e) r.hasOwnProperty(t) && (a[t] = e[t]);
        }
        ne && ee && (A(ne, g, oe), A("mousedown", x), A("load", w)),
          (re.destroy = function () {
            t && t.disconnect(),
              N(ne, g),
              N("mousedown", x),
              N("keydown", S),
              N("resize", o),
              N("load", w);
          }),
          window.SmoothScrollOptions && re(window.SmoothScrollOptions),
          "function" == typeof define && define.amd
            ? define(function () {
                return re;
              })
            : "object" == typeof exports
            ? (module.exports = re)
            : (window.SmoothScroll = re);
      })();
      /*jshint ignore: end*/

      //reset scroller on ajax
      if (firstload === 0) {
        window.scrollTo(0, 0);
        moduleGradientScroll.setAttribute(
          "style",
          "transform: scale(1) translateX(0) translateY(0) translateZ(0);"
        );
      }

      //shim request animation frame
      (function () {
        var vendors = ["webkit", "moz", "ms", "o"],
          vp = null;
        for (
          var x = 0;
          x < vendors.length &&
          !window.requestAnimationFrame &&
          !window.cancelAnimationFrame;
          x++
        ) {
          vp = vendors[x];
          window.requestAnimationFrame =
            window.requestAnimationFrame ||
            window[vp + "RequestAnimationFrame"];
          window.cancelAnimationFrame =
            window.cancelAnimationFrame ||
            window[vp + "CancelAnimationFrame"] ||
            window[vp + "CancelRequestAnimationFrame"];
        }
        if (
          /iP(ad|hone|od).*OS 6/.test(window.navigator.userAgent) ||
          !window.requestAnimationFrame ||
          !window.cancelAnimationFrame
        ) {
          //iOS6 is buggy.
          var lastTime = 0;
          window.requestAnimationFrame = function (callback, element) {
            var now = window.performance.now();
            var nextTime = Math.max(lastTime + 16, now);
            return setTimeout(function () {
              callback((lastTime = nextTime));
            }, nextTime - now);
          };
          window.cancelAnimationFrame = clearTimeout;
        }
      })();

      var raf =
        window.requestAnimationFrame ||
        window.webkitRequestAnimationFrame ||
        window.mozRequestAnimationFrame ||
        window.msRequestAnimationFrame ||
        window.oRequestAnimationFrame ||
        function (callback) {
          window.setTimeout(callback, 1000 / 60);
        };
      var $window = $(window);
      var lastScrollTop = $window.scrollTop();

      if (raf) {
        loop();
      }

      function loop() {
        var scrollTop = $window.scrollTop();
        if (lastScrollTop === scrollTop) {
          raf(loop);
          return;
        } else {
          lastScrollTop = scrollTop;

          //firmHero
          if (firmHero) {
            var firmNewPos = firmHeroInit - lastScrollTop;
            if (firmNewPos < 0) {
              firmText.setAttribute(
                "style",
                "transform: scale(1) translateX(0) translateY(0) translateZ(0);"
              );
            } else {
              firmText.setAttribute(
                "style",
                "transform: scale(1) translateX(0) translateY(-" +
                  firmNewPos +
                  "px) translateZ(0);"
              );
            }
          }

          //gradient scroll on navigation
          moduleGradientScroll.setAttribute(
            "style",
            "transform: scale(1) translateX(0) translateY(-" +
              lastScrollTop +
              "px) translateZ(0);"
          );

          // --- module hero scroll
          if (moduleHero) {
            var moduleHeroImage = moduleHero.querySelector(
              ".module--hero__image"
            );
            var slideOffset = parseInt(moduleHeroImage.offsetTop),
              parallaxSpeed = 3,
              parallaxYPos =
                ((slideOffset - lastScrollTop) / parallaxSpeed) * 0.9;
            moduleHeroImage.setAttribute(
              "style",
              "transform: scale(1) translateX(-50%) translateY(" +
                parallaxYPos +
                "px) translateZ(0);"
            );
          }

          // --- navigation scroll -- only on homepage
          if (lastScrollTop >= window.innerHeight * 0.6) {
            html.classList.add("is--scroll-visible");
          } else {
            html.classList.remove("is--scroll-visible");
          }

          // --- module hit
          moduleItems.forEach(function (el, i) {
            //animation on hit
            if (el.offsetTop - lastScrollTop >= window.innerHeight) {
              el.classList.remove("is--hit");
            } else {
              el.classList.add("is--hit");
            }
          });

          raf(loop);
        }
      }
    } else {
      var scrollbar = Scrollbar.init(ScrollArea);
      bindAjaxScrollbarWheel();
      var lastPosition = 0;
      var lastKnownPosition = 0;
      //reset scroller on ajax
      if (firstload === 0) {
        scrollbar.scrollTo(0, 0);
        moduleGradientScroll.setAttribute(
          "style",
          "transform: scale(1) translateX(0) translateY(0) translateZ(0);"
        );
      }

      // --- scroll event stuff on main
      scrollbar.addListener(function (status) {
        lastPosition = status.offset.y;
        var newScrollPosition = status.offset.y;
        var direction;

        if (newScrollPosition < lastKnownPosition) {
          direction = "up";
        } else {
          direction = "down";
        }

        //firmHero
        if (firmHero) {
          var firmNewPos = firmHeroInit - lastPosition;
          if (firmNewPos < 0) {
            firmText.setAttribute(
              "style",
              "transform: scale(1) translateX(0) translateY(0) translateZ(0);"
            );
          } else {
            firmText.setAttribute(
              "style",
              "transform: scale(1) translateX(0) translateY(-" +
                firmNewPos +
                "px) translateZ(0);"
            );
          }
        }

        // console.log( lastPosition );
        // console.log( textOverlayWrapper.offsetTop );
        // console.log( textOverlayInit - lastPosition );
        //  if( textOverlayWrapper && lastPosition > window.innerHeight - (headerWrapper.offsetHeight * 2) ){
        // var textOverlayNewPos = textOverlayInit + window.innerHeight - (headerWrapper.offsetHeight * 2) - lastPosition;
        // if( textOverlayNewPos < textOverlayText.offsetHeight / 2){
        // 	textOverlayText.setAttribute('style','transform: scale(1) translateX(0) translateY(-50%) translateZ(0);');
        // }else{
        // 	textOverlayText.setAttribute('style','transform: scale(1) translateX(0) translateY(-'+ textOverlayNewPos +'px) translateZ(0);');
        // }
        //  }

        if (
          textOverlayWrapper &&
          lastPosition > window.innerHeight - headerWrapper.offsetHeight * 2
        ) {
          var textOverlayNewPos =
            textOverlayInit +
            window.innerHeight -
            headerWrapper.offsetHeight * 2 -
            lastPosition;
          if (textOverlayNewPos < 0) {
            textOverlayText.setAttribute(
              "style",
              "transform: scale(1) translateX(0) translateY(0) translateZ(0);"
            );
          } else {
            textOverlayText.setAttribute(
              "style",
              "transform: scale(1) translateX(0) translateY(-" +
                textOverlayNewPos +
                "px) translateZ(0);"
            );
          }
        }

        //gradient scroll on navigation
        moduleGradientScroll.setAttribute(
          "style",
          "transform: scale(1) translateX(0) translateY(-" +
            lastPosition +
            "px) translateZ(0);"
        );

        // --- module hero scroll
        if (moduleHero) {
          var moduleHeroImage = moduleHero.querySelector(
            ".module--hero__image"
          );
          var slideOffset = parseInt(moduleHeroImage.offsetTop),
            parallaxSpeed = 3,
            parallaxYPos = ((slideOffset - lastPosition) / parallaxSpeed) * 0.9;
          moduleHeroImage.setAttribute(
            "style",
            "transform: scale(1) translateX(-50%) translateY(" +
              parallaxYPos +
              "px) translateZ(0);"
          );
        }

        if (lastPosition <= 10) {
          html.classList.add("hero-contrast")
        } else {
          html.classList.remove("hero-contrast")
        }


        // --- navigation scroll -- only on homepage
        if (lastPosition >= window.innerHeight * 0.6) {
          html.classList.add("is--scroll-visible");
        } else {
          html.classList.remove("is--scroll-visible");
        }


        // --- module hit
        moduleItems.forEach(function (el, i) {
          //animation on hit
          if (el.offsetTop - lastPosition >= window.innerHeight) {
            el.classList.remove("is--hit");
          } else {
            el.classList.add("is--hit");
          }
        });

        lastKnownPosition = newScrollPosition;
      }); //end scrollbars
    }
  };
  globalScripts(html, body, headerWrapper, firstload);

  //navigation
  const hamburger = document.querySelector(".hamburger"),
    primaryNav = document.querySelector(".primary--nav"),
    navItems = primaryNav.querySelectorAll("li");

  hamburger.addEventListener("click", function () {
    if (html.classList.contains("is--nav-visible")) {
      html.classList.remove("is--nav-visible");
      Array.from(navItems).forEach(function (el, i) {
        setTimeout(function () {
          el.classList.remove("is--nav-intro");
        }, i * 90);
      });
    } else {
      html.classList.add("is--nav-visible");
      Array.from(navItems).forEach(function (el, i) {
        setTimeout(function () {
          el.classList.add("is--nav-intro");
        }, i * 90);
      });
    }
  });

  // ########################################
  //  AJAX ENGINE - RELOAD ALL SCRIPTS HERE
  // ########################################
  function reloadScripts() {
    //global vars
    const html = document.querySelector("html"),
      body = html.querySelector("body"),
      headerWrapper = document.querySelector(".header--wrapper");
    var firstload = 0;
    globalScripts(html, body, headerWrapper, firstload);

    var hero = document.querySelector(".module--hero");
    if (hero) {
      html.classList.add("is--loaded__hero");
      html.classList.add("hero-contrast");
    }

    //reload ajax links
    ajaxLinksGlobal("#page-content");
    ajaxLinksGlobal(".header--wrapper");
    ajaxLinksGlobal("#primary--nav");
  }

  // ########################################
  //  AJAX INTRO - is intro animation
  // ########################################
  const introAnim = function () {
    html.classList.add("is--intro");
    setTimeout(function () {
      html.classList.remove("is--outro");
      html.classList.remove("is--intro");
    }, 900);
  };

  // ########################################
  //  AJAX ENGINE - written by Dan Villanueva
  // ########################################
  const ajaxRequest = function (url) {
    //var urlnocache = url + "?nocache="+Math.random();
    const urlnocache = url;
    const request = new XMLHttpRequest();
    request.open("GET", urlnocache, true);

    var ajaxContainer = document.querySelector("#ajax--content"),
      languageContainer = document.querySelector("#language-switcher"),
      languageContent = document.querySelector(".language-switcher"),
      primaryNavContainer = document.querySelector("#primary--nav"),
      primaryNavContent = document.querySelector(".primary--nav"),
      currentContent = document.querySelector("#main--scrollbar"),
      sublineContainer = document.querySelector(".subline-wrapper"),
      sublineContent = document.querySelector(".subline"),
      logoContainer = document.querySelector(".brand--wrapper"),
      logoContent = document.querySelector(".brand");

    request.onload = function () {
      if (
        request.readyState === 4 &&
        request.status === 200 &&
        request.status !== 400
      ) {
        // Success!
        const data = request.responseText,
          parser = new DOMParser(),
          doc = parser.parseFromString(data, "text/html"),
          newContent = doc.querySelector("#main--scrollbar"),
          newLanguageSwitcher = doc.querySelector(".language-switcher"),
          newPrimaryNav = doc.querySelector(".primary--nav"),
          newSubline = doc.querySelector(".subline-wrapper"),
          newLogo = doc.querySelector(".brand--wrapper");

        //history trick
        history.pushState("", "", url);

        //steps to load content
        if (currentContent.parentNode) {
          currentContent.parentNode.removeChild(currentContent);
          ajaxContainer.appendChild(newContent);
          languageContent.parentNode.removeChild(languageContent);
          languageContainer.appendChild(newLanguageSwitcher);
          primaryNavContent.parentNode.removeChild(primaryNavContent);
          primaryNavContainer.appendChild(newPrimaryNav);
          sublineContent.parentNode.removeChild(sublineContent);
          sublineContainer.appendChild(newSubline);
          logoContent.parentNode.removeChild(logoContent);
          logoContainer.appendChild(newLogo);

          //set title and body classes
          document.title = newContent.dataset.title;
          var newClasses = newContent.dataset.classes;
          var firstImage = newContent.querySelector("img");
          body.setAttribute("class", newClasses);

          const contentImages = newContent.querySelectorAll("img");

          //ios hack to load srcset images on ajax
          Array.from(contentImages).forEach(function (el, i) {
            el.outerHTML = el.outerHTML;
          });

          //scroll to top
          introAnim();

          //if theres hash anchor
          if (url.indexOf("#") !== -1) {
          }
        }
      } else {
        window.location.href = "/404";
      }
    };
    request.onerror = function (evt) {};

    //reload scripts on ajax load
    request.addEventListener("load", reloadScripts);
    request.send();
  };

  // ########################################
  //  AJAX OUTRO - is outro animation
  // ########################################
  const outroAnim = function (url) {
    //html.classList.remove('is--nav-visible');
    if (html.classList.contains("is--nav-visible")) {
      document.querySelector(".hamburger").click();
    }
    html.classList.add("is--outro");
    html.classList.remove("is--scroll-visible");
    html.classList.remove("is--loaded__hero");
      html.classList.remove("hero-contrast");
    //ajaxRequest(url);
    const mainWrapper = document.querySelector(".main"),
      moduleItemsHit = document.querySelectorAll(".module"),
      moduleItemsHitCount = moduleItemsHit.length;

    moduleItemsHit.forEach(function (el, i) {
      setTimeout(function () {
        el.classList.add("is--outro-anim");
        if (i + 1 === moduleItemsHitCount) {
          setTimeout(function () {
            ajaxRequest(url);
          }, 900);
        }
      }, i * 90);
    });
  };

  // ########################################
  //  AJAX LINKS - global links to activate ajax
  // ########################################
  const ajaxLinksGlobal = function (el) {
    const ajaxLinksContainer = document.querySelector(el),
      ajaxLinks = ajaxLinksContainer.querySelectorAll("a");
    Array.from(ajaxLinks).forEach(function (ajaxLink, i) {
      ajaxLink.addEventListener("click", function (e) {
        //e.preventDefault();
        const url = ajaxLink.getAttribute("href");
        if (
          ajaxLink.getAttribute("target") === "_blank" ||
          url.indexOf("mailto:") !== -1 ||
          url.indexOf("tel:") !== -1 ||
          (ajaxLink.getAttribute("download") &&
            ajaxLink.getAttribute("download") !== "") ||
          ajaxLink.classList.contains("vcard")
        ) {
          //run these links on default browser event
        } else if (ajaxLink.classList.contains("js--history-back")) {
          e.preventDefault();
          if (window.history.state == null) {
            //run ajax through history back link
            outroAnim(url);
          } else {
            //run ajax through history back button
            window.history.go(-1);
          }
        } else if (ajaxLink.classList.contains("back-to-top")) {
          //scrollbarhero.scrollIntoView(ScrollAreaHero.querySelector('.module--hero-scroller__item'));
          e.preventDefault();

          var ua = window.navigator.userAgent;
          var trident = ua.indexOf("Trident/");
          var edge = ua.indexOf("Edge/");
          if (trident > 0 || edge > 0) {
            $("html,body").animate(
              {
                scrollTop: 0,
              },
              1000
            );
          } else {
            //reload scrollbars - not sure if this is optimal way
            var Scrollbar = window.Scrollbar,
              ScrollArea = document.querySelector("#main--scrollbar"),
              scrollbar = Scrollbar.init(ScrollArea);
            scrollbar.scrollIntoView(ScrollArea.querySelector("#page-content"));
          }
        } else if (ajaxLink.classList.contains("scroll--intro")) {
          e.preventDefault();

          var ua = window.navigator.userAgent;
          var trident = ua.indexOf("Trident/");
          var edge = ua.indexOf("Edge/");
          if (trident > 0 || edge > 0) {
            $("html,body").animate(
              {
                scrollTop: document.querySelector("#intro").offsetTop,
              },
              1000
            );
          } else {
            //reload scrollbars - not sure if this is optimal way
            var Scrollbar = window.Scrollbar,
              ScrollArea = document.querySelector("#main--scrollbar"),
              scrollbar = Scrollbar.init(ScrollArea);
            scrollbar.scrollIntoView(ScrollArea.querySelector("#intro"));
          }
        } else {
          //run ajax links
          e.preventDefault();
          outroAnim(url);
        }
      });
    });
  };
  ajaxLinksGlobal("#page-content");
  ajaxLinksGlobal(".primary--nav");
  ajaxLinksGlobal(".header--wrapper");

  // ########################################
  //  AJAX HISTORY - history popstate stuff
  // ########################################
  window.addEventListener("popstate", function (event) {
    outroAnim(location.href);
  });

  /*********************
  Object Fit IE Polyfill
  **********************/
  objectFitImages();
})(jQuery); // Fully reference jQuery after this point.
